import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useImperativeHandle,
  forwardRef,
  useMemo,
} from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  Chip,
  Divider,
  Fab,
  FilledInput,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  IconButton,
  Input,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Paper,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  AppBar,
  Toolbar,
} from "@mui/material";
import clsx from "clsx";
import { styled } from "@mui/styles";
import { grey, blue, deepPurple, deepOrange } from "@mui/material/colors";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import customStyles from "app/shared-components/SelectCustomStyle";
import Select from "react-select";
import AgGridTable from "../../utilities/AgGridTable";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CustomAccordion from "../../utilities/CustomAccordion";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import jwtDecode from "jwt-decode";
import "./modal.css";
import {
  GetReasonEditor,
  GetSubReasonEditor,
  PictureEditorParams,
  carcassEditor,
  colorEditor,
  handleEditor,
  rangeEditor,
  uploadSingleFilePopup,
} from "./CustomCellEditor";
import { checkABNumber } from "../../utilities/FormValidation";
import DeliveryDelay from "./DeliveryDelay";
import { toast } from "react-toastify";
import PDFViewer from "app/shared-components/PDFViewer";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import AmendmentDetails from "./AmendmentDetails";
import { useTheme } from "@mui/material/styles";
import mammoth from "mammoth";
import {
  useOrderDetailStyles,
  tabsProps,
  tabSx,
  OrderToolbar,
  ToolbarField,
  SectionHeader,
  CommentItem,
} from "./OrderDetailUIHelpers";
import OrderDetailDialogs from "./Orderdetaildialogs";
const DownloadPDF = (props) => {
  const theme = useTheme();

  return (
    <svg
      width={69}
      height={71}
      viewBox="0 0 69 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M40.1259 2.64001H9.24001V63.36H56.76V19.2741L40.1259 2.64001ZM39.6 19.8V5.80595L53.5941 19.8H39.6Z"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M22.6953 40V32H25.8516C26.4583 32 26.9753 32.1159 27.4023 32.3477C27.8294 32.5768 28.1549 32.8958 28.3789 33.3047C28.6055 33.7109 28.7188 34.1797 28.7188 34.7109C28.7188 35.2422 28.6042 35.7109 28.375 36.1172C28.1458 36.5234 27.8138 36.8398 27.3789 37.0664C26.9466 37.293 26.4232 37.4062 25.8086 37.4062H23.7969V36.0508H25.5352C25.8607 36.0508 26.1289 35.9948 26.3398 35.8828C26.5534 35.7682 26.7122 35.6107 26.8164 35.4102C26.9232 35.207 26.9766 34.974 26.9766 34.7109C26.9766 34.4453 26.9232 34.2135 26.8164 34.0156C26.7122 33.8151 26.5534 33.6602 26.3398 33.5508C26.1263 33.4388 25.8555 33.3828 25.5273 33.3828H24.3867V40H22.6953ZM32.6533 40H29.8174V32H32.6768C33.4814 32 34.1742 32.1602 34.7549 32.4805C35.3356 32.7982 35.7822 33.2552 36.0947 33.8516C36.4098 34.4479 36.5674 35.1615 36.5674 35.9922C36.5674 36.8255 36.4098 37.5417 36.0947 38.1406C35.7822 38.7396 35.333 39.1992 34.7471 39.5195C34.1637 39.8398 33.4658 40 32.6533 40ZM31.5088 38.5508H32.583C33.083 38.5508 33.5036 38.4622 33.8447 38.2852C34.1885 38.1055 34.4463 37.8281 34.6182 37.4531C34.7926 37.0755 34.8799 36.5885 34.8799 35.9922C34.8799 35.401 34.7926 34.918 34.6182 34.543C34.4463 34.168 34.1898 33.8919 33.8486 33.7148C33.5075 33.5378 33.0869 33.4492 32.5869 33.4492H31.5088V38.5508ZM37.8203 40V32H43.1172V33.3945H39.5117V35.3008H42.7656V36.6953H39.5117V40H37.8203Z"
        fill="white"
      />
      <circle cx={56} cy={58} r={13} fill={theme.palette.secondary.main} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3333 56V54.6667H60C61.1046 54.6667 62 55.5621 62 56.6667V62C62 63.1046 61.1046 64 60 64H52C50.8954 64 50 63.1046 50 62V56.6667C50 55.5621 50.8954 54.6667 52 54.6667H52.6667V56H52C51.6318 56 51.3333 56.2985 51.3333 56.6667V62C51.3333 62.3682 51.6318 62.6667 52 62.6667H60C60.3682 62.6667 60.6667 62.3682 60.6667 62V56.6667C60.6667 56.2985 60.3682 56 60 56H59.3333ZM56.6965 57.3649L57.4776 56.5931C57.7496 56.3243 58.1906 56.3243 58.4627 56.5931C58.7347 56.8619 58.7347 57.2977 58.4627 57.5665L56 60L53.5373 57.5665C53.2653 57.2977 53.2653 56.8619 53.5373 56.5931C53.8094 56.3243 54.2504 56.3243 54.5224 56.5931L55.3035 57.3649V52.0217C55.3035 51.6415 55.6153 51.3334 56 51.3334C56.3847 51.3334 56.6965 51.6415 56.6965 52.0217V57.3649Z"
        fill="white"
      />
    </svg>
  );
};
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  backgroundColor: theme.palette.secondary.main,

  padding: "12px 10px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "block",
  textAlign: "center",
  position: "relative",

  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },

  "&[disabled]": {
    opacity: 0.4,
    background: theme.palette.action.disabledBackground,

    "& .file": {
      cursor: "not-allowed",
    },
  },

  "& .file": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    cursor: "pointer",
  },
}));

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const initialStatusOption = [
  { label: "New", value: "NEW" },
  { label: "Assigned", value: "ASSIGNED" },
  { label: "In-Progress", value: "IN_PROGRESS" },
  { label: "Hold", value: "HOLD" },
  { label: "Order Placed", value: "ORDER_PLACED" },
  { label: "Factory Acknowledged", value: "ACK_FRM_FACTORY" },
  { label: "AB Received", value: "AB_RECEIVED" },
  { label: "Under Confirmation", value: "UNDER_CONFIRMATION" },
  { label: "Confirmed", value: "CONFIRMED" },
  { label: "Ready To Book", value: "READY_TO_BOOK" },
  { label: "Production Planning", value: "PRODUCTION_PLANNING" },
  { label: "PI Generated", value: "PI_GENERATED" },
  { label: "Ready To Release", value: "READY_TO_RELEASE" },
  { label: "Released", value: "RELEASED" },
  { label: "Loaded", value: "LOADED" },
  { label: "Invoiced", value: "INVOICED" },
];
const getFileExtension = (filename) => {
  const match = filename.match(/\.([a-z0-9]+)$/i);
  return match ? match[1].toLowerCase() : null;
};
export const Modal = ({ src, type, alt, onClose }) => {
  const [renderedHtml, setRenderedHtml] = useState(null);
  useEffect(() => {
    let cancelled = false;

    const convert = async () => {
      if (type === "word" && src) {
        const result = await mammoth.convertToHtml({ arrayBuffer: src });
        if (!cancelled) setRenderedHtml(result.value);
      }
    };

    convert();
    return () => {
      cancelled = true;
    };
  }, [src, type]);

  return (
    <div className="modal">
      <span className="close" onClick={onClose}>
        &times;
      </span>

      {type === "pdf" && (
        <div className="modal-content">
          <PDFViewer url={src} />
        </div>
      )}

      {type === "video" && (
        <video
          className="modal-content"
          src={src}
          controls
          autoPlay
          style={{ maxWidth: "100%" }}
        />
      )}

      {type === "image" && (
        <img className="modal-content" src={src} alt={alt} />
      )}

      {type === "word" && (
        <div
          className="modal-content"
          style={{
            background: "#fff",
            padding: 16,
            maxHeight: "80vh",
            overflow: "auto",
          }}
          dangerouslySetInnerHTML={{
            __html: renderedHtml || "Loading preview…",
          }}
        />
      )}

      {type === "unsupported" && (
        <div
          className="modal-content"
          style={{ padding: 24, textAlign: "center", background: "#fff" }}
        >
          Preview not available for this file type. Please download it instead.
        </div>
      )}
    </div>
  );
};

const initialStatuses = [
  "NEW",
  "ASSIGNED",
  "IN_PROGRESS",
  "HOLD",
  // "ORDER_PLACED",
  "",
  null,
  undefined,
];

const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
const orderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const aoRoReasonsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.aoRoReasons}`;

const OrderDetail = forwardRef((props, childref) => {
  const classes = useOrderDetailStyles(props);
  const [tabValue, setTabValue] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [listOfRevisions, setListOfRevisions] = useState([]);
  const [editRowData, setEditRowData] = useState([]);
  const [itemData, setItemData] = useState([
    {
      id: 0,
      range: "",
      priceGroup: "",
      color: "",
      carCass: "",
      handle: "",
    },
  ]);
  const [partData, setPartData] = useState([]);
  const [editPartData, setEditPartData] = useState([]);
  const gridRef = useRef();
  const gridRefItems = useRef();
  const viewerPDF = useRef();
  const theme = useTheme();
  const navigate = useNavigate();
  const gridRefDownload = useRef();
  const gridRefPartOrder = useRef();
  const params = useParams();
  const [user, setUser] = useState();
  const [expanded, setExpanded] = useState("panel1");
  const [orderExpanded, setOrderExpanded] = useState("panel1");
  const [commercialExpanded, setCommercialExpanded] = useState("panel1");
  const [abNumber, setAbNumber] = useState("");
  const [additionalRevision, setAdditionalRevision] = useState([]);
  const [saveBtnDisable, setSaveBtnDisable] = useState(true);
  const [openAttachment, setOpenAttachment] = useState(false);
  const [ABSendOpen, setABSendOpen] = useState(false);
  const [ABReceivedOpen, setABReceivedOpen] = useState(false);
  const ref = useRef(null);
  const [status, setStatus] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [statusOption, setStatusOption] = useState([]);
  const [partSelectedRow, setPartSelectedRow] = useState([]);
  const [amendmentSelectedRow, setAmendmentSelectedRow] = useState([]);
  const [loadingWeekOptions, setLoadingWeekOptions] = useState([]);
  const [freightOptions, setFreightOptions] = useState([]);
  const [itemSelectedRow, setItemSelectedRow] = useState([]);
  const [downloadSelectedRow, setDownloadSelectedRow] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [amendmentFileData, setAmendmentFileData] = useState([]);
  const [editAmendmentFileData, setEditAmendmentFileData] = useState([]);
  const [orderData, setOrderData] = useState();
  const [editOrderData, setEditOrderData] = useState();
  const [editItemData, setEditItemData] = useState();
  const [sendCustomerABFile, setSendCustomerABFile] = useState();
  const [orderComments, setOrderComments] = useState([]);
  const [ammendmentComment, setAmmendmentComment] = useState();
  const [editOrderComments, setEditOrderComments] = useState([]);
  const [annotationABFile, setAnnotationABFile] = useState([]);
  const [newOrderComment, setNewOrderComment] = useState();
  const [ABFiles, setABFiles] = useState();
  const [attachmentSelectedRow, setAttachmentSelectedRow] = useState();
  const [editableRow, setEditableRow] = useState(false);
  const [disableData, setDisableData] = useState(props?.disableData);
  const [ABNo, setABNo] = useState("");
  const [formOpen, setFormOpen] = useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [showroomOptions, setShowroomOptions] = useState([]);
  const [orderStatusOption, setOrderStatusOption] =
    useState(initialStatusOption);
  const [error, setError] = useState();
  const [allUserList, setAllUserList] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [lvDocumentInfoesList, setLvDocumentInfoesList] = useState([]);
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const amendmentUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.OrderABFiles}`;
  const historyUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderHistories}`;
  const uploadOrderFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.uploadOrderFile}`;
  const userURL = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}?size=1000`;
  const lvDocUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.lvDocumentInfoes}`;
  const hiddenPictureFile = useRef(null);
  const uploadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.uploadPicture}`;
  const uploadAmendmentFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.uploadAmendment}`;
  const getDateUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getDate}`;
  const getWeekUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getWeek}`;
  const orderStatuses = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.nextAllowedOrderStatus}`;
  const [partMailContent, setPartMailContent] = useState();
  const [showSendGermany, setShowSendGermany] = useState(true);
  const [openPDF, setOpenPDF] = useState(false);
  const [abFileUrl, setAbFileUrl] = useState("");
  const [shareAbFileName, setShareAbFileName] = useState();
  const [amendmentIndex, setAmendmentIndex] = useState();
  const [amendmentUpdateStatus, setAmendmentUpdateStatus] = useState(false);
  const [abNumberError, setAbNumberError] = useState("");
  const [territoryOptions, setTerritoryOptions] = useState();
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const hasPORSOPRole = [
    "ROLE_SOPDIR",
    "ROLE_ORDERPRO",
    "ROLE_MD",
    "ROLE_ADMIN",
  ].some((role) => token?.scope?.includes(role));
  const hasSopAdminRole = ["ROLE_SOPDIR", "ROLE_MD", "ROLE_ADMIN"].some(
    (role) => token?.scope?.includes(role),
  );
  const hasPORSOPADMINRole = [
    "ROLE_SOPDIR",
    "ROLE_ORDERPRO",
    "ROLE_ADMIN",
  ].some((role) => token?.scope?.includes(role));
  const hasSOPADMINRole = ["ROLE_SOPDIR", "ROLE_ADMIN"].some((role) =>
    token?.scope?.includes(role),
  );
  const hasPartnerRole = ["ROLE_PARTNER"].some((role) =>
    token?.scope?.includes(role),
  );
  const hasLogisticsRole = ["ROLE_LOGIMGR", "ROLE_LOGISTICS"].some((role) =>
    token.scope.includes(role),
  );
  const hasPartnersRole = [
    "ROLE_PARTNER",
    "ROLE_PARTNER_ADMIN",
    "ROLE_SHWRMMGR",
    "ROLE_PARTNRDESIGN",
    "ROLE_PARTNRORDPROCESS",
  ].some((role) => token?.scope?.includes(role));
  const hasSOPRole = ["ROLE_SOPDIR"].some((role) =>
    token?.scope?.includes(role),
  );
  const hasCustomerRole = [
    "ROLE_PARTNRORDPROCESS",
    "ROLE_PARTNER_ADMIN",
    "ROLE_PARTNER",
    "ROLE_PARTNRDESIGN",
    "ROLE_PARTNRSALE",
    "ROLE_SHWRMMGR",
  ].some((role) => token?.scope?.includes(role));
  const hasCustomerPartnersRole = [
    "ROLE_PARTNRORDPROCESS",
    "ROLE_PARTNER",
    "ROLE_PARTNRDESIGN",
    "ROLE_PARTNRSALE",
    "ROLE_SHWRMMGR",
  ].some((role) => token?.scope?.includes(role));
  const [isOpen, setIsOpen] = useState(false);
  const [pictureSrc, setPictureSrc] = useState("");
  const [pictureType, setPictureType] = useState("");
  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format("DD-MM-YYYY - HH:mm");
  };
  const PREVIEWABLE_VIDEO = ["mp4", "webm", "ogg", "mov"];
  const PREVIEWABLE_WORD = ["docx"]; // .doc not supported client-side

  const showModal = async (src) => {
    const rawUrl = src.currentTarget.attributes.src.nodeValue;
    const fileExtension = getFileExtension(rawUrl)?.toLowerCase();

    try {
      if (fileExtension === "pdf") {
        const file = await OAuthService.getDownload(rawUrl);
        const blob = new Blob([file?.data], { type: "application/pdf" });
        setPictureSrc(URL.createObjectURL(blob));
        setPictureType("pdf");
      } else if (PREVIEWABLE_VIDEO.includes(fileExtension)) {
        const file = await OAuthService.getDownload(rawUrl);
        const blob = new Blob([file?.data], { type: `video/${fileExtension}` });
        setPictureSrc(URL.createObjectURL(blob));
        setPictureType("video");
      } else if (PREVIEWABLE_WORD.includes(fileExtension)) {
        const file = await OAuthService.getDownload(rawUrl);
        setPictureSrc(file?.data);
        setPictureType("word");
      } else if (
        ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(fileExtension)
      ) {
        setPictureSrc(rawUrl);
        setPictureType("image");
      } else {
        // unsupported preview — force user to just download
        setPictureSrc(rawUrl);
        setPictureType("unsupported");
      }
      setIsOpen(true);
    } catch (Error) {
      setError(Error.error);
    }
  };

  const [columnItemDefs, setColumnItemDefs] = useState([
    {
      field: "range",
      headerName: "Range*",
      type: "editableColumn",
      cellEditor: rangeEditor,
    },
    { field: "rangeId", hide: true },
    { field: "colorId", hide: true },
    { field: "carcassId", hide: true },
    { field: "handleId", hide: true },
    {
      field: "priceGroup",
      headerName: "Price Group*",
      maxWidth: 100,
      editable: false,
    },
    {
      field: "color",
      headerName: "Color*",
      type: "editableColumn",
      cellEditor: colorEditor,
    },
    {
      field: "carcass",
      headerName: "Carcass*",
      type: "editableColumn",
      cellEditor: carcassEditor,
    },
    {
      field: "handle",
      headerName: "Handle*",
      type: "editableColumn",
      cellEditor: handleEditor,
    },
  ]);

  const showActionBtn = (props, disable) => {
    const handleBtnDownload = async () => {
      const downloadUrl = url + "/api/downloadOrderFile";
      const download = await OAuthService.getDownload(
        downloadUrl + `?orderAttachmentId=${props?.data?.id}`,
      );
      const blob = download?.data;
      if (blob) {
        const url = window.URL.createObjectURL(
          new Blob([blob], { type: "application/octet-stream" }),
        );
        const link = document.createElement("a");
        link.href = url;
        link.download = `${props?.data?.commissionName}_${props?.data?.attachmentName}`;
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    };

    const handleDeleteAttachment = () => {
      const rowData = props?.node;
      rowData.setDataValue("attachmentName", "");
      rowData.setDataValue("attachmentFile", "");
      rowData.setDataValue("uploadedBy", "");
      rowData.setDataValue("uploadedDttm", "");
      rowData.setDataValue("comments", "");
      props?.api?.refreshCells();
      const allData = [];
      props?.api?.forEachNode((node) => {
        allData.push(node?.data);
      });
      setRowData(allData);
    };

    const handleEditAttachment = () => {
      setOpenAttachment(true);
      setAttachmentSelectedRow(props);
    };

    const handleAddAttachment = () => {
      setOpenAttachment(true);
      setAttachmentSelectedRow(props);
    };
    return (
      <>
        {props?.data?.attachmentName ? (
          <>
            {props?.data?.type !== "Revised Drawing file" && (
              <Button
                size="small"
                color="secondary"
                onClick={handleEditAttachment}
                disabled={!disable || hasLogisticsRole}
              >
                <FuseSvgIcon size={18}>material-solid:edit</FuseSvgIcon>
              </Button>
            )}
            {props?.data?.type !== "Revised Drawing file" && (
              <Button
                size="small"
                color="secondary"
                onClick={handleDeleteAttachment}
                disabled={!disable || hasLogisticsRole}
                sx={{ display: props?.data?.type === "DRW*" ? "none" : null }}
              >
                <FuseSvgIcon size={18}>material-solid:delete</FuseSvgIcon>
              </Button>
            )}
            {props?.data?.id && (
              <Button
                size="small"
                color="secondary"
                onClick={handleBtnDownload}
              >
                <FuseSvgIcon size={18}>material-solid:download</FuseSvgIcon>
              </Button>
            )}
          </>
        ) : (
          <Button
            size="small"
            color="secondary"
            onClick={handleAddAttachment}
            disabled={!disable || hasLogisticsRole}
          >
            <FuseSvgIcon size={18}>material-solid:add</FuseSvgIcon>
          </Button>
        )}
      </>
    );
  };

  const showPictureActionBtn = (props, disable) => {
    const handlePictDownload = async () => {
      try {
        const downloadUrl = url + "api/static/downloadPicture";
        const download = await OAuthService.getDownload(
          downloadUrl + `?picture=${props?.data?.picture}`,
        );
        const blob = download?.data;
        if (blob) {
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: "application/octet-stream" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.download = `${props?.data?.posNo}_${props?.data?.picture}`;
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      } catch (Error) {
        setError(Error.error);
      }
    };
    const handleAddPicture = async (e) => {
      props.api.startEditingCell({
        rowIndex: props.rowIndex,
        colKey: "picture",
      });
    };
    return (
      <>
        {props?.data?.picture ? (
          <>
            {props?.data?.picture && (
              <>
                <Button
                  size="small"
                  color="secondary"
                  onClick={handlePictDownload}
                >
                  <FuseSvgIcon size={18}>material-solid:download</FuseSvgIcon>
                </Button>
                <Button
                  size="small"
                  color="secondary"
                  onClick={showModal}
                  src={`${url}api/static/downloadPicture?picture=${props?.data?.picture}`}
                >
                  <FuseSvgIcon
                    className="text-48"
                    size={18}
                    sx={{ color: theme.palette.secondary.main }}
                  >
                    heroicons-outline:eye
                  </FuseSvgIcon>
                </Button>
              </>
            )}
          </>
        ) : (
          <Button
            size="small"
            color="secondary"
            onClick={handleAddPicture}
            disabled={hasLogisticsRole}
          >
            <FuseSvgIcon size={18}>material-solid:add</FuseSvgIcon>
          </Button>
        )}
      </>
    );
  };

  const [columnDefs, setColumnDefs] = useState([
    { field: "type", editable: false },
    { field: "attachmentName" },
    { field: "uploadedBy" },
    { field: "uploadedDttm", cellRenderer: handleDateFormat },
    // { field: "comments" },
    {
      field: "attachmentFile",
      headerName: "Action",
      type: "editableColumn",
      cellRenderer: (params) => showActionBtn(params, disableData),
    },
  ]);

  const PictEditorParams = forwardRef((props, ref) => {
    // console.log('UPLOAD', props)
    const { data, colDef, node } = props;
    const [pictureFile, setPictureFile] = useState("");

    const handlePictureUpload = async (e) => {
      const fileUploaded = e.target.files[0];
      setError();
      if (fileUploaded.size > 15000000) {
        setError("Please select file less than 10MB");
        return;
      }
      const formData = new FormData();
      formData.append("file", fileUploaded);
      try {
        const response = await OAuthService.uploadFile(uploadUrl, formData);
        setPictureFile(response.data.fileName);
        node.setDataValue("picture", response.data.fileName);
        const newData = { ...data.data, picture: response.data.fileName }; //, rowIndex: node.rowIndex
      } catch (error) {
        setError(error.message);
      }
    };

    useEffect(() => {
      if (props.data.picture) {
        setPictureFile(props.data.picture);
      }
    }, [props.data]);

    const removePictureFile = () => {
      //TODO Call delete file API to delete uploaded file on server
      setPictureFile("");
      if (data.imgUpldReqd) {
        setIsReasonSelected(false);
      }
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          const rowData = props.node;
          rowData.setDataValue("picture", pictureFile);
          return pictureFile;
        },
      };
    });

    return (
      <>
        {!pictureFile && (
          <ColorButton
            variant="contained"
            component="label"
            disabled={pictureFile}
            style={{
              padding: "1px 10px",
              width: "36px",
              margin: "0 auto",
              cursor: "pointer",
            }}
          >
            <FuseSvgIcon size={16}>heroicons-outline:upload</FuseSvgIcon>
            <input
              type="file"
              className="file"
              onChange={handlePictureUpload}
              ref={hiddenPictureFile}
              disabled={pictureFile}
            />
          </ColorButton>
        )}
        {pictureFile && (
          <Box>
            <Chip
              label={pictureFile}
              onDelete={removePictureFile}
              sx={{
                height: "20px",
                width: "100%",

                "& span": {
                  fontSize: "10px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                },
                "& svg.MuiChip-deleteIcon": {
                  fontSize: "14px",
                  margin: "0 3px 0 -6px",
                },
              }}
            />
          </Box>
        )}
      </>
    );
  });
  const canViewCommercial = () => {
    if (hasPartnersRole || hasLogisticsRole) return false;

    const roles = token?.scope || [];
    const isOrderPro = roles.includes("ROLE_ORDERPRO");

    if (isOrderPro && roles.length === 1) return false;

    return true;
  };
  const [partColumnDefs, setPartColumnDefs] = useState([
    {
      field: "posNo",
      type: "editableColumn",
      cellClassRules: {
        "custom-style": (params) =>
          params?.data?.postnNumReqd && !params?.data?.posNo,
      },
    },
    { field: "articleCode", type: "editableColumn" },
    { field: "reason", cellEditor: GetReasonEditor, type: "editableColumn" },
    {
      field: "subReason",
      headerName: "Sub Category",

      type: "editableSubReasonColumn",
      cellEditor: GetSubReasonEditor,
      cellClassRules: {
        "custom-style": (params) =>
          !!params?.data?.subReasons?.length && !params?.data?.subReason,
      },
    },
    { field: "subReasons", hide: true },
    {
      field: "picture",
      cellRenderer: (props) => showPictureActionBtn(props),
      editable: true,
      // cellEditorPopup: true,
      cellEditor: PictEditorParams,
      cellClassRules: {
        "custom-style": (params) =>
          params?.data?.imgUpldReqd && !params?.data?.picture,
      },
    },
    {
      field: "remark",
      type: "editableColumn",
      cellEditor: "agLargeTextCellEditor",
      cellEditorPopup: true,
      editable: true,
      singleClickEdit: true,
      cellEditorParams: {
        rows: 10,
        cols: 50,
        maxLength: 500,
      },
    },
    { field: "imgUpldReqd", hide: true, type: "editableColumn" },
    { field: "postnNumReqd", hide: true, type: "editableColumn" },
  ]);

  const statusIndex = initialStatusOption.findIndex(
    (row) => row.value === orderData?.orderStatus,
  );

  const handleAttachmentClose = () => {
    setOpenAttachment(false);
  };

  const onGridReady = (params) => {};
  const onGridReadyAmendment = (params) => {};

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    const updatedColDef = [...columnDefs];
    updatedColDef.map((col) => {
      if (col.field === "attachmentFile") {
        col.cellRenderer = (params) =>
          showActionBtn(params, props?.disableData);
      }
    });
    setColumnDefs(updatedColDef);
  }, [props?.disableData]);

  // Set the tab value base on previous page location
  useEffect(() => {
    const pathName = sessionStorage.getItem("pathName");
    if (
      pathName === "/order/amendment-request-list" ||
      pathName === "/order/customer-conf-list"
    ) {
      setTabValue(1);
    }
    sessionStorage.removeItem("pathName");
  }, []);
  //Render the page after updating the amendment status
  useEffect(() => {
    if (amendmentUpdateStatus) {
      getOrder();
      getOrderHistory();
      getAmmendment();
    }
  }, [amendmentUpdateStatus]);

  const handleDeleteOrder = async () => {
    setError();
    setOpenDelete(true);
  };

  const handleDeleteClose = () => {
    setOpenDelete(false);
  };

  const handleDeleteConfirm = async () => {
    try {
      let response = await OAuthService.addData(
        url + `api/deleteOrder?orderId=${params.id}`,
        "",
      );
      if (response.data == true) {
        toast.success("Order deleted successfully!");
        navigate("/order/order-list");
      }
    } catch (error) {
      toast.error(
        "There was an error while deleting order. " +
          error?.response?.data?.errorMessage || error?.message,
      );
    }
    setOpenDelete(false);
  };

  const handleUpdateOrder = async () => {
    setSuccessMsg("");
    if (
      status === "ORDER_PLACED" &&
      (
        !orderData.revisedDrawingFile ||
        rowData.filter(
          (data) => data.type === "Revised Drawing file" && data.attachmentName,
        )
      ).length === 0
    ) {
      setError("Revised file is not uploaded");
    } else {
      const updateData = { ...orderData };
      delete updateData?._links;
      updateData.orderStatus = editOrderData?.orderStatus;

      updateData.commissionName = buildCommissionName(
        editOrderData,
        updateData,
      );
      Object.keys(updateData).forEach((key) => {
        if (
          key.startsWith("range") ||
          key.startsWith("carcass") ||
          key.startsWith("color") ||
          key.startsWith("handle") ||
          key.startsWith("priceGroup")
        ) {
          delete updateData[key];
        }
      });

      itemData.forEach((item, i) => {
        let index = i + 1;
        updateData["range" + index] = item.range;
        updateData["range" + index + "Id"] = item.rangeId;
        updateData["carcass" + index + "Id"] = item.carcassId;
        updateData["color" + index + "Id"] = item.colorId;
        updateData["handle" + index + "Id"] = item.handleId;
        updateData["carcass" + index] = item.carcass;
        updateData["color" + index] = item.color;
        updateData["handle" + index] = item.handle;
        updateData["priceGroup" + index] = item.priceGroup;
      });
      for (let i = itemData.length + 1; i <= 3; i++) {
        updateData["range" + i] = null;
        updateData["range" + i + "Id"] = null;
        updateData["carcass" + i + "Id"] = null;
        updateData["color" + i + "Id"] = null;
        updateData["handle" + i + "Id"] = null;
        updateData["carcass" + i] = null;
        updateData["color" + i] = null;
        updateData["handle" + i] = null;
        updateData["priceGroup" + i] = null;
      }

      try {
        rowData.length > 0 &&
          (await Promise.all(
            rowData.map(async (row) => {
              if (row.type === "Appliance Detail*") {
                if (row.attachmentFile) {
                  const payload = {
                    file: [row.attachmentFile],
                    customerId: updateData?.customerNum,
                    commissionName: updateData?.commissionName,
                    isOriginal: true,
                  };
                  await OAuthService.addFiles(
                    `${uploadOrderFileUrl}`,
                    payload,
                  ).then((list) => {
                    const data = list.data;
                    const fileId = data.map((file) => file.id);
                    if (data) {
                      updateData.applianceDetail = data[0];
                    }
                  });
                } else {
                  if (!row.attachmentName) {
                    updateData.applianceDetail = null;
                  }
                }
              } else if (row.type === "DRW*") {
                if (row.attachmentFile) {
                  const payload = {
                    file: [row.attachmentFile],
                    customerId: updateData?.customerNum,
                    commissionName: updateData?.commissionName,
                    isOriginal: true,
                  };
                  await OAuthService.addFiles(
                    `${uploadOrderFileUrl}`,
                    payload,
                  ).then((list) => {
                    const data = list?.data;
                    const fileId = data.map((file) => file.id);
                    if (data) {
                      updateData.drwFile = data[0];
                    }
                  });
                } else {
                  if (!row.attachmentName) {
                    delete updateData.drwFile;
                  }
                }
              } else if (row.type === "Special Discount") {
                if (row.attachmentFile) {
                  const payload = {
                    file: [row.attachmentFile],
                    customerId: updateData?.customerNum,
                    commissionName: updateData?.commissionName,
                    isOriginal: true,
                  };
                  await OAuthService.addFiles(
                    `${uploadOrderFileUrl}`,
                    payload,
                  ).then((list) => {
                    const data = list.data;
                    const fileId = data.map((file) => file.id);
                    if (data) {
                      updateData.specialDiscountFile = data[0];
                    }
                  });
                } else {
                  if (!row.attachmentName) {
                    updateData.specialDiscountFile = null;
                  }
                }
              } else if (row.type === "Revised Drawing file") {
                if (row.attachmentFile) {
                  const payload = {
                    file: [row.attachmentFile],
                    customerId: updateData?.customerNum,
                    commissionName: updateData?.commissionName,
                    isOriginal: false,
                  };
                  await OAuthService.addFiles(
                    `${uploadOrderFileUrl}`,
                    payload,
                  ).then((list) => {
                    const data = list.data;
                    const fileId = data.map((file) => file.id);
                    if (data) {
                      updateData.revisedDrawingFile = data[0];
                    }
                  });
                } else {
                  if (!row.attachmentName) {
                    if (updateData.revisedDrawingFile) {
                      if (updateData.revisedDrawingFile.attachmentFile) {
                        const payload = {
                          file: [updateData.revisedDrawingFile.attachmentFile],
                          customerId: updateData?.customerNum,
                          commissionName: updateData?.commissionName,
                          isOriginal: false,
                        };
                        await OAuthService.addFiles(
                          `${uploadOrderFileUrl}`,
                          payload,
                        ).then((list) => {
                          const data = list?.data;
                          const fileId = data.map((file) => file.id);
                          if (data) {
                            updateData.revisedDrawingFile = data[0];
                          }
                        });
                      } else {
                        updateData.revisedDrawingFile = null;
                      }
                    } else {
                      updateData.revisedDrawingFile = null;
                    }
                  }
                }
              } else if (row.type === "Order Checklist*") {
                if (row.attachmentFile) {
                  const payload = {
                    file: [row.attachmentFile],
                    customerId: updateData?.customerNum,
                    commissionName: updateData?.commissionName,
                    isOriginal: true,
                  };
                  await OAuthService.addFiles(
                    `${uploadOrderFileUrl}`,
                    payload,
                  ).then((list) => {
                    const data = list.data;
                    const fileId = data.map((file) => file.id);
                    if (data) {
                      updateData.orderCheckList = data[0];
                    }
                  });
                } else {
                  if (!row.attachmentName) {
                    updateData.orderCheckList = null;
                  }
                }
              } else if (row.type === "Drawing file") {
                if (row.attachmentFile) {
                  const payload = {
                    file: [row.attachmentFile],
                    customerId: updateData?.customerNum,
                    commissionName: updateData?.commissionName,
                    isOriginal: true,
                  };

                  await OAuthService.addFiles(
                    `${uploadOrderFileUrl}`,
                    payload,
                  ).then((list) => {
                    if (!list?.data || !Array.isArray(list?.data)) {
                      return;
                    }

                    const listdata = list.data;
                    if (!Array.isArray(updateData.orderAttachments)) {
                      updateData.orderAttachments = [];
                    }

                    let updatedAttachments = [...updateData.orderAttachments];

                    if (listdata.length > 0) {
                      if (row?.id) {
                        updatedAttachments = updatedAttachments.map((data) =>
                          data?.id === row?.id ? listdata[0] : data,
                        );
                      } else {
                        updatedAttachments.push(listdata[0]);
                      }
                    }
                    updateData.orderAttachments = [...updatedAttachments];
                  });
                } else {
                  if (!row.attachmentName && row?.id) {
                    updateData.orderAttachments =
                      updateData.orderAttachments?.filter(
                        (data) => data?.id !== row?.id,
                      );

                    if (
                      !updateData.orderAttachments ||
                      updateData.orderAttachments.length < 1
                    ) {
                      updateData.orderAttachments = [];
                    }
                  }
                }
              }

              return row;
            }),
          ));

        if (partData.length > 0) {
          updateData.partOrderDetails = partData.map(
            ({ subReasons, ...rest }) => rest,
          );
        }
        if (
          !updateData?.drwFile?.attachmentName &&
          updateData?.documentType == "SO"
        ) {
          setSaveBtnDisable(false);
          toast.error("Please add a file. The DRW file cannot be empty.");
          return;
        }
        const updated = await OAuthService.updateData(
          orderUrl,
          params.id,
          updateData,
        );

        if (status && editOrderData !== status) {
          if (status === "ASSIGNED") {
            await OAuthService.addData(
              url +
                `/api/assignorders?orderIds=${params.id}&userMailId=${updateData?.assignedTo}`,
              "",
            );
          } else {
            if (status !== "ACK_FRM_FACTORY") {
              await OAuthService.addData(
                url +
                  `/api/changeOrderStatus?orderId=${params.id}&status=${status}`,
                "",
              );
            }
          }
        }
        if (ABNo && status === "ACK_FRM_FACTORY") {
          await OAuthService.putData(
            url + `/api/updateAbInOrder/${params?.id}/${ABNo}`,
            "",
          );
        }
        if (updated?.data) {
          setSuccessMsg("Order Updated successfully.");
          getOrder();
          getOrderHistory();
          getAmmendment();
          setStatus("");
        }
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    }
  };

  useImperativeHandle(childref, () => ({
    handleUpdateOrder: handleUpdateOrder,
    handleDeleteOrder: handleDeleteOrder,
  }));
  const handleSubmitComments = async () => {
    setSuccessMsg("");
    if (newOrderComment) {
      const commentSource =
        token?.scope?.includes("ROLE_PARTNER_ADMIN") ||
        token?.scope?.includes("ROLE_SHWRMMGR") ||
        token?.scope?.includes("ROLE_PARTNRDESIGN") ||
        token?.scope?.includes("ROLE_PARTNER") ||
        token?.scope?.includes("ROLE_PARTNRORDPROCESS")
          ? "PARTNER"
          : token?.scope?.includes("ROLE_ADMIN") ||
            token?.scope?.includes("ROLE_MD") ||
            token?.scope?.includes("ROLE_SOPDIR") ||
            token?.scope?.includes("ROLE_IAM") ||
            token?.scope?.includes("ROLE_DESIGNER") ||
            token?.scope?.includes("ROLE_ORDERPRO")
          ? "NFZE"
          : "";
      if (orderData?.comments) {
        orderData.comments = [
          {
            user: token?.email,
            comment: newOrderComment,
            time: new Date(),
            orderCommentSource: commentSource,
          },
        ];
      } else {
        orderData.comments = [
          {
            user: token?.email,
            comment: newOrderComment,
            time: new Date(),
            orderCommentSource: commentSource,
          },
        ];
      }
      try {
        await OAuthService.addData(
          url + `api/addComments/${params?.id}`,
          orderData.comments,
        );
        getOrder();
        getOrderHistory();
        getAmmendment();
        setNewOrderComment("");
      } catch (error) {
        toast.error(error.error);
      }
    }
  };

  const handleSubmitAmmendmentComments = async (data, index) => {
    setSuccessMsg("");
    const updated = [...amendmentFileData];
    const commentSource =
      token?.scope?.includes("ROLE_PARTNER_ADMIN") ||
      token?.scope?.includes("ROLE_SHWRMMGR") ||
      token?.scope?.includes("ROLE_PARTNRDESIGN") ||
      token?.scope?.includes("ROLE_PARTNER") ||
      token?.scope?.includes("ROLE_PARTNRORDPROCESS")
        ? "PARTNER"
        : token?.scope?.includes("ROLE_ADMIN") ||
          token?.scope?.includes("ROLE_MD") ||
          token?.scope?.includes("ROLE_SOPDIR") ||
          token?.scope?.includes("ROLE_IAM") ||
          token?.scope?.includes("ROLE_DESIGNER") ||
          token?.scope?.includes("ROLE_ORDERPRO")
        ? "NFZE"
        : "";

    try {
      await OAuthService.updateData(amendmentUrl, updated[index]?.id, {
        comments: [
          ...updated[index].comments,
          {
            user: token.email,
            comment: ammendmentComment,
            time: new Date(),
            orderCommentSource: commentSource,
          },
        ],
      });
      getOrder();
      getOrderHistory();
      getAmmendment();
      setAmmendmentComment(" ");
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const handleABUploadClose = () => {
    setABSendOpen(false);
  };

  const handleUploadCustomerABFile = (e) => {
    const file = e.target.files[0];
    setSendCustomerABFile({ name: file?.name, file: file });
  };

  const handleABFileCustomer = async () => {
    setSuccessMsg("");
    if (sendCustomerABFile && amendmentFileData.length > 0) {
      try {
        await OAuthService.addFiles(
          url +
            `/api/sendAbNotification?abFileId=${amendmentFileData[0]?.id}&orderId=${orderData?.id}`,
          { abPdf: sendCustomerABFile.file },
        );
        handleABUploadClose();
        setSuccessMsg("AB file send to customer successfully");
        getOrder();
        getOrderHistory();
        getAmmendment();
      } catch (error) {
        handleABUploadClose();
        setError(error?.response?.data?.errorMessage || error.message);
      }
    }
  };

  const handleABReceviedClose = () => {
    setABReceivedOpen(false);
    if (orderData?.orderStatus === "AB_RECEIVED" && !ABFiles) {
      setSaveBtnDisable(true);
    } else {
      setSaveBtnDisable(false);
    }
  };

  const handleABRecevied = async () => {
    setSuccessMsg("");
    if (ABFiles) {
      try {
        await OAuthService.addFiles(
          url +
            `/api/uploadAbFile?orderId=${params?.id}&abNumber=${
              orderData?.abNumber
            }&wg1=${orderData?.lpWg1}&wg2=${orderData?.lpWg2}&factoryContact=${
              orderData?.factoryContact || null
            }&factoryContactPhone=${
              orderData?.factoryContactPhone || null
            }&factoryContactEmail=${orderData?.factoryContactEmail || null}`,
          { abPdf: ABFiles.attachmentFile },
        );
        handleABReceviedClose();
        setSuccessMsg("AB file uploaded successfully");
        getOrder();
        getOrderHistory();
        getAmmendment();
      } catch (error) {
        handleABReceviedClose();
        setError(error?.response?.data?.errorMessage || error.message);
      }
    }
  };
  const NON_NEGATIVE_FIELDS = [
    "revisedLpWg1",
    "lpWg1",
    "lpWg2",
    "revisedLpWg2",
    "volume",
    "weight",
    "plannedLoadingWeek",
    "actualLoadingWeek",
  ];
  const blockInvalidNumberKeys = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };
  const isValidNumber = (val) => {
    if (val === "" || val === null || val === undefined) return true;
    return (
      /^\d*\.?\d*$/.test(val) && !isNaN(Number(val)) && isFinite(Number(val))
    );
  };
  const handleOrderDetailChange = async (name, value) => {
    if (NON_NEGATIVE_FIELDS.includes(name)) {
      if (!isValidNumber(value)) {
        toast.warn("Please enter a valid number");
        return;
      }
      if (Number(value) < 0) {
        toast.warn("Negative values are not allowed");
        setOrderData({ ...orderData, [name]: 0 });
        return;
      }
    }
    if (name === "freight") {
      setOrderData({ ...orderData, freight: value.value, freightId: value.id });
    } else if (name === "splDiscWg1") {
      let disCountWG1 = {
        orderId: params.id,
        splDiscWg1: Number(value),
      };
      let SPLData = await OAuthService.addData(
        url + "api/calculateDiscount",
        disCountWG1,
      );

      setOrderData({
        ...orderData,
        totalDiscWg1: SPLData.data.totalDiscWg1,
        [name]: value,
        stdDiscWg1: SPLData.data.stdDiscWg1,
        totalDiscWg1Wg2: SPLData.data.totalDiscWg1Wg2,
      });
    } else if (name === "showroomName") {
      setOrderData({
        ...orderData,
        showroomNum: value.value,
        showroomName: value.label,
        region: value.region,
      });
    } else if (name === "splDiscWg2") {
      let disCountWG1 = {
        orderId: params.id,
        splDiscWg2: Number(value),
      };
      let SPLData = await OAuthService.addData(
        url + "api/calculateDiscount",
        disCountWG1,
      );

      setOrderData({
        ...orderData,
        totalDiscWg2: SPLData.data.totalDiscWg2,
        [name]: value,
        stdDiscWg2: SPLData.data.stdDiscWg2,
        totalDiscWg1Wg2: SPLData.data.totalDiscWg1Wg2,
      });
    } else if (name === "splDiscWG1Payable") {
      let disCountWG1 = {
        orderId: params.id,
        promoDiscWg1: Number(value),
      };
      let SPLData = await OAuthService.addData(
        url + "api/calculateDiscount",
        disCountWG1,
      );

      setOrderData({
        ...orderData,
        totalDiscWG1Payable: SPLData.data.totalDiscWG1Payable,
        [name]: value,
        totalDiscWg1Wg2Payable: SPLData.data.totalDiscWg1Wg2Payable,
        stdDiscWG1Payable: SPLData.data.stdDiscWG1Payable,
      });
    } else if (name === "splDiscWG2Payable") {
      let disCountWG1 = {
        orderId: params.id,
        promoDiscWg1: Number(value),
      };
      let SPLData = await OAuthService.addData(
        url + "api/calculateDiscount",
        disCountWG1,
      );

      setOrderData({
        ...orderData,
        totalDiscWG2Payable: SPLData.data.totalDiscWG2Payable,
        [name]: value,
        totalDiscWg1Wg2Payable: SPLData.data.totalDiscWg1Wg2Payable,
        stdDiscWG2Payable: SPLData.data.stdDiscWG2Payable,
      });
    } else if (name === "plannedLoadingWeek") {
      let week = Number(value);

      if (week && week > 0) {
        const list = await OAuthService.getList(`${getDateUrl}?week=${week}`);
        const data = list?.data ? moment(list.data).format("YYYY-MM-DD") : null;

        setOrderData({
          ...orderData,
          plannedLoadingWeek: week,
          plannedLoadingDate: data,
        });
      } else {
        setOrderData({
          ...orderData,
          plannedLoadingWeek: null,
          plannedLoadingDate: null,
        });
      }
    } else if (name === "plannedLoadingDate") {
      if (!value) {
        setOrderData({
          ...orderData,
          plannedLoadingDate: null,
          plannedLoadingWeek: null,
        });
        return;
      }

      const list = await OAuthService.getList(`${getWeekUrl}?date=${value}`);

      setOrderData({
        ...orderData,
        plannedLoadingDate: value,
        plannedLoadingWeek: list?.data || null,
      });
    } else if (name === "actualLoadingWeek") {
      let week = Number(value);

      if (week && week > 0) {
        const list = await OAuthService.getList(`${getDateUrl}?week=${week}`);
        const data = list?.data ? moment(list.data).format("YYYY-MM-DD") : null;

        setOrderData({
          ...orderData,
          actualLoadingWeek: week,
          actualLoadingDate: data,
        });
      } else {
        setOrderData({
          ...orderData,
          actualLoadingWeek: null,
          actualLoadingDate: null,
        });
      }
    } else if (name === "actualLoadingDate") {
      if (!value) {
        setOrderData({
          ...orderData,
          actualLoadingDate: null,
          actualLoadingWeek: null,
        });
        return;
      }

      const list = await OAuthService.getList(`${getWeekUrl}?date=${value}`);

      setOrderData({
        ...orderData,
        actualLoadingDate: value,
        actualLoadingWeek: list?.data || null,
      });
    } else if (name === "abNumber") {
      const error = checkABNumber(value);

      setOrderData({
        ...orderData,
        [name]: value,
      });

      setAbNumberError(error || "");
    } else if (name === "territory") {
      setOrderData({
        ...orderData,
        territory: value?.value || null,
      });
    } else if (name === "createdByUser") {
      setOrderData({
        ...orderData,
        createdByUser: value?.value || null,
      });
    } else if (name === "uniqueId") {
      const updatedUniqueId = value?.toUpperCase();
      setOrderData({
        ...orderData,
        uniqueId: updatedUniqueId,
      });
    } else if (name === "clientName") {
      const updatedClientName = value?.toUpperCase();
      setOrderData({
        ...orderData,
        clientName: updatedClientName,
      });
    } else {
      setOrderData({
        ...orderData,
        [name]: value === "" || value === undefined ? null : value,
      });
    }
  };
  const addItemRow = useCallback(() => {
    let newRow = {
      range: "",
      rangeId: "",
      color: "",
      colorId: "",
      handle: "",
      handleId: "",
      carcass: "",
      carcassId: "",
      priceGroup: "",
      vendorNum: orderData?.vendorNum,
    };
    const RowIndex = itemData.length;
    const rowsData = [...itemData];
    rowsData && rowsData.splice(RowIndex, 0, newRow);
    setItemData(rowsData);
    gridRefItems.current.api.applyTransaction({
      add: [newRow],
      addIndex: RowIndex,
    });
    gridRefItems.current.api.refreshCells();
    setTimeout(() => {
      gridRefItems.current.api.setFocusedCell(RowIndex, "range");
      gridRefItems.current.api.startEditingCell({
        rowIndex: RowIndex,
        colKey: "range",
      });
    });
    const allData = [];
    gridRefItems.current.api.forEachNode((node) => {
      allData.push(node.data);
    });
    setItemData(allData);
  }, [itemData]);

  const editItemRow = useCallback(() => {
    const index =
      itemData &&
      itemData?.findIndex(
        (row) => JSON.stringify(itemSelectedRow[0]) === JSON.stringify(row),
      );
    setTimeout(() => {
      gridRefItems.current.api.setFocusedCell(index, "range");
      gridRefItems.current.api.startEditingCell({
        rowIndex: index,
        colKey: "range",
      });
    }, 800);
  }, [itemData, itemSelectedRow]);

  const deleteItemRow = useCallback(() => {
    const selectedRow = gridRefItems.current.api.getSelectedRows();
    gridRefItems?.current?.api.applyTransaction({ remove: selectedRow });

    let index = itemData.findIndex(
      (row) => JSON.stringify(row) === JSON.stringify(selectedRow[0]),
    );

    itemData.splice(index, 1);
    gridRefItems.current.api.refreshCells();
    const allData = [];
    gridRefItems.current.api.forEachNode((node) => {
      allData.push(node.data);
    });
    setItemData(allData);
  }, [itemData]);
  const addDownloadRow = useCallback(() => {
    let newRow = {
      type: "Drawing file",
      attachmentName: "",
      uploadedBy: "",
      uploadedDttm: "",
      comments: "",
      commissionName: orderData?.commissionName,
      download: "",
      imgUpldReqd: "",
      postnNumReqd: "",
    };
    const RowIndex = rowData.length;
    const rowsData = [...rowData];
    rowsData && rowsData.splice(RowIndex, 0, newRow);
    setRowData(rowsData);
    gridRefDownload.current.api.applyTransaction({
      add: [newRow],
      addIndex: RowIndex,
    });
    gridRefDownload.current.api.refreshCells();
    setTimeout(() => {
      gridRefDownload.current.api.setFocusedCell(RowIndex, "attachmentName");
      gridRefDownload.current.api.startEditingCell({
        rowIndex: RowIndex,
        colKey: "attachmentName",
      });
    });
    const allData = [];
    gridRefDownload.current.api.forEachNode((node) => {
      allData.push(node.data);
    });
    setRowData(allData);
  }, [rowData]);

  const handlePictureUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (fileUploaded.size > 15000000) {
      setError("Please select file less than 10MB");
      return;
    }
    const formData = new FormData();
    formData.append("file", fileUploaded);
    try {
      const response = await OAuthService.uploadFile(uploadUrl, formData);
      setPictureFile(response.data.fileName);
      node.setDataValue("picture", response.data.fileName);
      const newData = { ...data.data, picture: response.data.fileName }; //, rowIndex: node.rowIndex
      if (
        (!newData.postnNumReqd || (newData.posNo && newData.postnNumReqd)) &&
        (!newData.imgUpldReqd ||
          (newData.picture.length > 0 && newData.imgUpldReqd))
      ) {
        setIsReasonSelected(true);
      } else {
        setIsReasonSelected(false);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const addPartRow = useCallback(() => {
    let newRow = {
      posNo: "",
      articleCode: "",
      reason: "",
      picture: "",
      remark: "",
      subReason: "",
      subReasons: [],
    };
    const RowIndex = partData.length;
    const rowsData = [...partData];
    rowsData && rowsData.splice(RowIndex, 0, newRow);
    setPartData(rowsData);
    gridRefPartOrder.current.api.applyTransaction({
      add: [newRow],
      addIndex: RowIndex,
    });
    gridRefPartOrder.current.api.refreshCells();

    gridRefPartOrder.current.api.setFocusedCell(RowIndex, "posNo");
    gridRefPartOrder.current.api.startEditingCell({
      rowIndex: RowIndex,
      colKey: "posNo",
    });

    const allData = [];
    gridRefPartOrder.current.api.forEachNode((node) => {
      allData.push(node.data);
    });
    setPartData(allData);
  }, [partData]);

  const editPartRow = useCallback(() => {
    const index =
      partData &&
      partData?.findIndex(
        (row) => JSON.stringify(partSelectedRow[0]) === JSON.stringify(row),
      );
    setTimeout(() => {
      gridRefPartOrder.current.api.setFocusedCell(index, "posNo");
      gridRefPartOrder.current.api.startEditingCell({
        rowIndex: index,
        colKey: "posNo",
      });
    }, 800);
  }, [partData, partSelectedRow]);

  const deletePartRow = useCallback(() => {
    const selectedRow = gridRefPartOrder.current.api.getSelectedRows();
    gridRefPartOrder?.current?.api.applyTransaction({ remove: selectedRow });

    let index = partData.findIndex(
      (row) => JSON.stringify(row) === JSON.stringify(selectedRow[0]),
    );

    partData.splice(index, 1);
    const allData = [];
    gridRefPartOrder.current.api.forEachNode((node) => {
      allData.push(node.data);
    });
    setPartData(allData);
    gridRefPartOrder.current.api.refreshCells();
  }, [partData]);

  const onBtAdd = useCallback(
    (index) => {
      let newRow = {
        posNo: "",
        articleCode: "",
        amendment: "",
        documentPath: "",
      };
      setAmendmentIndex(index);
      const updated = [...amendmentFileData];
      if (updated[index].listAdditionalRevisions) {
        updated[index].listAdditionalRevisions = [
          ...updated[index].listAdditionalRevisions,
          newRow,
        ];
      } else {
        updated[index].listAdditionalRevisions = [newRow];
      }
      setAmendmentFileData(updated);
    },
    [amendmentFileData],
  );

  useEffect(() => {
    const orderStatus = async () => {
      try {
        const list = await OAuthService.getList(url + "api/getorderstatuslist");
        if (list?.data) {
          const allCat = Object.entries(list.data).map(([value, label]) => ({
            value,
            label,
          }));
          setStatusOption(allCat);
        }
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    };
    orderStatus();

    const getUserList = async () => {
      const userData = await OAuthService.getList(userURL);
      setAllUserList(
        userData?.data?._embedded?.users?.map((option) => {
          return {
            email: option.email,
            lastName: option.lastName,
            firstName: option.firstName,
            id: option.companyId,
          };
        }),
      );
    };
    getUserList();
    const getLvDocList = async () => {
      try {
        const res = await OAuthService.getList(
          `${lvDocUrl}/search/findByOrderId?orderId=${params?.id}`,
        );
        setLvDocumentInfoesList(res.data?._embedded?.lvDocumentInfoes);
      } catch (e) {
        console.log("e - - - - >", e);
      }
    };
    getLvDocList();
  }, []);
  useEffect(() => {
    if (allUserList && orderData) {
      setFilterOptions(
        allUserList
          ?.filter((user) => user.id === orderData?.customerNum)
          ?.map((user) => {
            const lastName = user?.lastName || "";
            const firstName = user?.firstName || "";

            const name = `${firstName}  ${lastName}`.trim();

            return {
              label: name,
              value: user.email,
            };
          }),
      );
    }
  }, [allUserList, orderData]);

  const isCellEditable = useCallback(
    (params) => {
      if (props?.disableData) {
        return true;
      } else {
        return false;
      }
    },
    [editableRow, props?.disableData],
  );

  const columnTypes = useMemo(() => {
    return {
      editableColumn: {
        editable: (params) => isCellEditable(params),
      },
      editableSubReasonColumn: {
        editable: (params) =>
          isCellEditable(params) && !!params?.data?.subReasons?.length,
      },
    };
  }, [editableRow, props?.disableData]);

  const onSelectionPartChanged = (params) => {
    setPartSelectedRow(params.api.getSelectedRows());
  };
  const onSelectionAmendmentChanged = (params) => {
    setAmendmentSelectedRow(params.api.getSelectedRows());
  };
  const onSelectionItemChanged = (params) => {
    setItemSelectedRow(params.api.getSelectedRows());
  };
  const onSelectionDownloadChanged = (params) => {
    setDownloadSelectedRow(params.api.getSelectedRows());
  };
  const getOrder = async () => {
    try {
      if (params.id) {
        const freightOptionUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.freightOptions}`;
        let list = await OAuthService.getList(freightOptionUrl);
        let newOrder = list.data;

        const loadingWeek = Object.keys(newOrder?.loadingWeek).map((key) => ({
          value: key,
          label: newOrder.loadingWeek[key],
        }));
        setLoadingWeekOptions(loadingWeek);

        const freight = newOrder?.freightOptions.map((value) => {
          return {
            label: `${value.shippingMethodName}`,
            value: value.shippingMethodName,
            id: value.code,
          };
        });
        setFreightOptions(freight);

        const res = await OAuthService.getEditData(orderUrl, params.id);
        setOrderData(res?.data);
        setEditOrderData(JSON.parse(JSON.stringify(res?.data)));
        setAbNumber(res?.data?.abNumber);
        // setStatus(res?.data?.orderStatus);
        const itemsRowData = [];
        if (
          res?.data.range1 ||
          res?.data.priceGroup1 ||
          res?.data.color1 ||
          res?.data.carcass1 ||
          res?.data.handle1
        ) {
          itemsRowData.push({
            id: res?.data.id,
            range: res?.data.range1,
            rangeId: res?.data.range1Id,
            priceGroup: res?.data.priceGroup1,
            color: res?.data.color1,
            colorId: res?.data.color1Id,
            carcass: res?.data.carcass1,
            carcassId: res?.data.carcass1Id,
            handle: res?.data.handle1,
            handleId: res?.data.handle1Id,
            vendorNum: res?.data?.vendorNum,
          });
        }

        if (
          res?.data.range2 ||
          res?.data.priceGroup2 ||
          res?.data.color3 ||
          res?.data.carcass3 ||
          res?.data.handle3
        ) {
          itemsRowData.push({
            id: res?.data.id,
            range: res?.data.range2,
            rangeId: res?.data.range2Id,
            priceGroup: res?.data.priceGroup2,
            color: res?.data.color2,
            colorId: res?.data.color2Id,
            carcass: res?.data.carcass2,
            carcassId: res?.data.carcass2Id,
            handle: res?.data.handle2,
            handleId: res?.data.handle2Id,
            vendorNum: res?.data?.vendorNum,
          });
        }

        if (
          res?.data.range3 ||
          res?.data.priceGroup3 ||
          res?.data.color3 ||
          res?.data.carcass3 ||
          res?.data.handle3
        ) {
          itemsRowData.push({
            id: res?.data.id,
            range: res?.data.range3,
            rangeId: res?.data.range3Id,
            priceGroup: res?.data.priceGroup3,
            color: res?.data.color3,
            colorId: res?.data.color3Id,
            carcass: res?.data.carcass3,
            carcassId: res?.data.carcass3Id,
            handle: res?.data.handle3,
            handleId: res?.data.handle3Id,
            vendorNum: res?.data?.vendorNum,
          });
        }
        const updatedItemData = [...itemsRowData];
        setItemData(updatedItemData);

        setEditItemData(JSON.parse(JSON.stringify(updatedItemData)));
        if (res?.data?.partOrderDetails) {
          let reasonList = [];
          try {
            const reasonRes = await OAuthService.getList(
              `${aoRoReasonsUrl}?size=1000`,
            );
            reasonList = reasonRes.data?._embedded?.aoRoReasons || [];
          } catch (e) {}

          const parts = res.data.partOrderDetails.map((p) => {
            const match = reasonList.find((r) => r.reason === p.reason);
            return { ...p, subReasons: match?.subReasons || [] };
          });
          setPartData(parts);
          setEditPartData(JSON.parse(JSON.stringify(parts)));
        }
        let listDownloadFile = [];
        if (res?.data?.applianceDetail) {
          listDownloadFile.push({
            type: "Appliance Detail*",
            id: res?.data?.applianceDetail.id,
            commissionName: res?.data?.commissionName,
            attachmentName: res?.data?.applianceDetail.attachmentName,
            uploadedBy: res?.data?.applianceDetail.uploadedBy,
            uploadedDttm: res?.data?.applianceDetail.uploadedDttm,
            comments: res?.data?.applianceDetail.comments,
          });
        } else {
          listDownloadFile.push({
            type: "Appliance Detail*",
            id: "",
            commissionName: res?.data?.commissionName,
            attachmentName: "",
            uploadedBy: "",
            uploadedDttm: "",
            comments: "",
          });
        }
        if (res?.data?.partOrderMailToGermany) {
          setPartMailContent(res?.data?.partOrderMailToGermany);
        }

        if (res?.data?.drwFile) {
          listDownloadFile.push({
            type: "DRW*",
            attachmentName: res?.data?.drwFile.attachmentName,
            uploadedBy: res?.data?.drwFile.uploadedBy,
            id: res?.data?.drwFile.id,
            commissionName: res?.data?.commissionName,
            uploadedDttm: res?.data?.drwFile.uploadedDttm,
            comments: res?.data?.drwFile.comments,
          });
        } else {
          listDownloadFile.push({
            type: "DRW*",
            attachmentName: "",
            id: "",
            commissionName: res?.data?.commissionName,
            uploadedBy: "",
            uploadedDttm: "",
            comments: "",
          });
        }

        if (res?.data?.specialDiscountFile) {
          listDownloadFile.push({
            type: "Special Discount",
            attachmentName: res?.data?.specialDiscountFile.attachmentName,
            uploadedBy: res?.data?.specialDiscountFile.uploadedBy,
            commissionName: res?.data?.commissionName,
            id: res?.data?.specialDiscountFile?.id,
            uploadedDttm: res?.data?.specialDiscountFile.uploadedDttm,
            comments: res?.data?.specialDiscountFile.comments,
          });
        } else {
          listDownloadFile.push({
            type: "Special Discount",
            attachmentName: "",
            id: "",
            commissionName: res?.data?.commissionName,
            uploadedBy: "",
            uploadedDttm: "",
            comments: "",
          });
        }

        if (res?.data?.revisedDrawingFile) {
          listDownloadFile.push({
            type: "Revised Drawing file",
            attachmentName: res?.data?.revisedDrawingFile.attachmentName,
            uploadedBy: res?.data?.revisedDrawingFile.uploadedBy,
            id: res?.data?.revisedDrawingFile?.id,
            commissionName: res?.data?.commissionName,
            uploadedDttm: res?.data?.revisedDrawingFile.uploadedDttm,
            comments: res?.data?.revisedDrawingFile.comments,
          });
        } else {
          listDownloadFile.push({
            type: "Revised Drawing file",
            attachmentName: "",
            uploadedBy: "",
            id: "",
            commissionName: res?.data?.commissionName,
            uploadedDttm: "",
            comments: "",
          });
        }

        if (res?.data?.orderAttachments) {
          res?.data?.orderAttachments?.map((file) => {
            listDownloadFile.push({
              type: "Drawing file",
              attachmentName: file?.attachmentName,
              id: file?.id,
              commissionName: res?.data?.commissionName,
              uploadedBy: file?.uploadedBy,
              uploadedDttm: file?.uploadedDttm,
              comments: file?.comments,
            });
          });
        }

        if (res?.data?.orderCheckList) {
          listDownloadFile.push({
            type: "Order Checklist*",
            attachmentName: res?.data?.orderCheckList.attachmentName,
            id: res?.data?.orderCheckList?.id,
            commissionName: res?.data?.commissionName,
            uploadedBy: res?.data?.orderCheckList.uploadedBy,
            uploadedDttm: res?.data?.orderCheckList.uploadedDttm,
            comments: res?.data?.orderCheckList.comments,
          });
        } else {
          listDownloadFile.push({
            type: "Order Checklist*",
            attachmentName: "",
            uploadedBy: "",
            uploadedDttm: "",
            commissionName: res?.data?.commissionName,
            id: "",
            comments: "",
          });
        }

        setRowData(listDownloadFile);
        setEditRowData(JSON.parse(JSON.stringify(listDownloadFile)));

        //set order status
        const orderStatus = res?.data?.orderStatus;
        const statusIndex = initialStatusOption.findIndex(
          (option) => option.value === orderStatus,
        );
        let updatedOptions;
        if (initialStatuses?.includes(orderStatus)) {
          updatedOptions = initialStatusOption.slice(0, 5);
        } else {
          updatedOptions = initialStatusOption.slice(
            statusIndex,
            statusIndex + 2,
          );
        }
        // setOrderStatusOption(updatedOptions);
        props?.setOrderType(res?.data?.documentType);
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };
  const userData = async () => {
    try {
      const list = await OAuthService.getList(
        userUrl + `?sort=firstName,asc&size=1000`,
      );
      const users = list.data?._embedded?.users.map((data, key) => {
        data.name = data.firstName + " " + data.lastName;
        return data;
      });
      const roleUsers = users.filter(
        (user) =>
          user.roles.includes("ROLE_DESIGNER") ||
          user.roles.includes("ROLE_DESGNSTHEAD") ||
          user.roles.includes("ROLE_ORDERPRO") ||
          user.roles.includes("ROLE_SOPDIR"),
      );
      setUser(
        roleUsers.map((item) => ({
          value: item.email,
          label: `${item.firstName} ${item.lastName}`,
        })),
      );
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  const getAmmendment = async () => {
    try {
      const amendments = await OAuthService.getList(
        amendmentUrl +
          `/search/findByOrderDocumentNoOrderByCreatedDateDesc?orderDocumentNo=${orderData?.documentNum}`,
      );
      if (amendments?.data) {
        setAmendmentFileData(amendments?.data?._embedded?.orderABFiles);

        setEditAmendmentFileData(
          JSON.parse(JSON.stringify(amendments?.data?._embedded?.orderABFiles)),
        );
        const revisions = amendments?.data?._embedded?.orderABFiles.map(
          (item) => item.listAdditionalRevisions,
        );
        setListOfRevisions(revisions);
        const shareAbsName = amendments?.data?._embedded?.orderABFiles.map(
          (item) => item.sharedAbFileName,
        );
        setShareAbFileName(shareAbsName);
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  const getOrderStatus = async () => {
    try {
      const list = await OAuthService.getList(
        orderStatuses +
          `/search/findByCurrentOrderStatus?orderStatus=${orderData?.orderStatus}`,
      );
      const data = list.data;
      const nextStatus = Array.isArray(data.allowedOrderStatus)
        ? data.allowedOrderStatus.map((item) => ({
            value: item,
            label: item,
          }))
        : [];

      const currentStatus = [
        { value: data.currentOrderStatus, label: data.currentOrderStatus },
        ...nextStatus,
      ];

      setOrderStatusOption(currentStatus);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          "Failed to load container status options.",
      );
    }
  };
  const getShowroomOptions = async () => {
    try {
      if (Number(orderData?.customerNum)) {
        const showroomByCompanyUrl = `${companiesUrl}/${orderData?.customerNum}/showrooms`;
        const list = await OAuthService.getList(showroomByCompanyUrl);
        let showrooms = list.data?._embedded?.showrooms;
        showrooms = showrooms.map((showroom) => {
          return {
            value: showroom.id,
            label: showroom.name,
            region: showroom.region,
          };
        });
        setShowroomOptions(showrooms);
      }
    } catch (error) {
      toast.error("Showroom data not available");
      toast.error(error.message);
    }
  };
  const getTerritoryOptions = async () => {
    try {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territory}?size=100`;
      const territories = await OAuthService.getList(url);
      const result = territories?.data?._embedded.territories.map((value) => {
        return {
          label: value.displayName,
          value: value?._links?.territory?.href.split("/").pop(),
          id: value?._links?.territory?.href.split("/").pop(),
        };
      });
      setTerritoryOptions(result);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const getOrderHistory = async () => {
    try {
      const history = await OAuthService.getList(
        historyUrl +
          `/search/findByOrderDocumentNumOrderByTimeDesc?string=${orderData?.documentNum}`,
      );
      if (history?.data) {
        setOrderHistory(history?.data?._embedded?.orderHistories);
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  const getComments = async () => {
    const commentsList = await OAuthService.getList(
      url + `/api/getComments?orderId=${params.id}`,
    );

    const lists = [];
    if (commentsList?.data?.commentList) {
      commentsList?.data?.commentList.map((data) => {
        if (data?.comment) {
          lists.push(data);
        }
      });
    }
    setOrderComments(lists);
    setEditOrderComments(JSON.parse(JSON.stringify(lists)));
  };
  const invalidItemColorRows = useMemo(() => {
    const invalid = {};
    itemData.forEach((row) => {
      if (row?.range && (!row?.color || !row?.carcass || !row?.handle)) {
        invalid[row.id] = true;
      }
    });
    return invalid;
  }, [itemData]);
  const isPartRowValid = (r) =>
    !!r?.reason &&
    (!r?.postnNumReqd || !!r?.posNo) &&
    (!r?.imgUpldReqd || !!r?.picture) &&
    (!r?.subReasons?.length || !!r?.subReason);
  const NAME_REGEX = /^[A-Z0-9-_\s]+$/i;

  const buildCommissionName = (original, current) => {
    if (!original?.commissionName) return original?.commissionName;

    let name = original.commissionName;
    const isPrj = ["PRJ", "CPRJ"].includes(original.orderCategory);

    const oldUnique = original.uniqueId?.toUpperCase();
    const newUnique = current?.uniqueId?.trim().toUpperCase();
    const oldClient = original.clientName?.toUpperCase();
    const newClient = current?.clientName?.trim().toUpperCase();

    if (newUnique && oldUnique !== newUnique) {
      name = isPrj
        ? name.replace(`-${oldUnique}`, `-${newUnique}`)
        : name.replace(`-${oldUnique}-`, `-${newUnique}-`);
    }

    if (newClient && oldClient !== newClient) {
      name = isPrj
        ? name.replace(`-${oldClient}-`, `-${newClient}-`)
        : name.replace(`-${oldClient}`, `-${newClient}`);
    }

    return name;
  };
  const MAX_COMMISSION_LENGTH = 35;

  const liveCommissionName = useMemo(
    () =>
      buildCommissionName(editOrderData, orderData) ??
      orderData?.commissionName ??
      "",
    [editOrderData, orderData?.uniqueId, orderData?.clientName],
  );

  const commissionCharsRemaining =
    MAX_COMMISSION_LENGTH - liveCommissionName.length;
  const validateCommissionFields = () => {
    if (!editOrderData || !orderData) return null;

    if (editOrderData.uniqueId !== orderData.uniqueId) {
      const v = orderData.uniqueId?.trim();
      if (!v) return "Unique Id cant be empty";
      if (!NAME_REGEX.test(v))
        return "Unique Id can only contain letters, numbers, '_', '-' and spaces";
    }

    if (editOrderData.clientName !== orderData.clientName) {
      const v = orderData.clientName?.trim();
      if (!v) return "Client Name cant be empty";
      if (!NAME_REGEX.test(v))
        return "Client Name can only contain letters, numbers, '_', '-' and spaces";
    }

    if (buildCommissionName(editOrderData, orderData)?.length > 35) {
      return "Commission Name cannot exceed 35 characters";
    }
    return null;
  };
  const getIsSaveEnabled = () => {
    const isChanged =
      JSON.stringify(orderData) !== JSON.stringify(editOrderData) ||
      JSON.stringify(orderComments) !== JSON.stringify(editOrderComments) ||
      JSON.stringify(itemData) !== JSON.stringify(editItemData) ||
      JSON.stringify(rowData) !== JSON.stringify(editRowData) ||
      JSON.stringify(partData) !== JSON.stringify(editPartData) ||
      newOrderComment ||
      ABFiles;

    if (!isChanged) {
      return false;
    }
    if (partData.some((r) => !isPartRowValid(r))) {
      return false;
    }
    if (Object.keys(invalidItemColorRows).length > 0) {
      return false;
    }
    if (validateCommissionFields()) {
      return false;
    }
    if (props?.disableData === false) {
      return true;
    }

    if (
      orderData?.volume &&
      orderData?.loadingWeek &&
      orderData?.freight &&
      orderData?.lpWg1 &&
      itemData.length >= 1
    ) {
      const filterMaterial = itemData.filter(
        (data) =>
          data.range &&
          data.carcass &&
          data.color &&
          data.handle &&
          data.priceGroup,
      );

      const filesFilter =
        rowData.length > 0
          ? rowData.filter((data) => {
              return (
                data.type === "DRW*" &&
                data?.documentType === "SO" &&
                data.attachmentName
              );
            })
          : [];

      if (filterMaterial.length >= 1 && filesFilter.length >= 1) {
        return true;
      }

      return false;
    }

    // Allow save if only partData edited
    if (JSON.stringify(partData) !== JSON.stringify(editPartData)) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    const isSaveEnabled = getIsSaveEnabled();

    setSaveBtnDisable(!isSaveEnabled);
  }, [
    orderData,
    itemData,
    editItemData,
    editRowData,
    editOrderData,
    editPartData,
    partData,
    rowData,
    ABFiles,
    orderComments,
    newOrderComment,
    props?.disableData,
    editOrderComments,
    invalidItemColorRows,
  ]);

  useEffect(() => {
    if (!props?.disableData) return;
    const msg = validateCommissionFields();
    if (msg) toast.warn(msg, { toastId: "commission-validation" });
  }, [orderData?.uniqueId, orderData?.clientName]);

  useEffect(() => {
    userData();
    getOrder();
    getComments();
    getTerritoryOptions();
  }, []);

  useEffect(() => {
    if (orderData?.documentNum) {
      getOrderHistory();
      getAmmendment();
    }
  }, [orderData?.documentNum]);
  useEffect(() => {
    if (orderData?.orderStatus) {
      getOrderStatus();
    }
  }, [orderData?.orderStatus]);
  useEffect(() => {
    if (orderData?.customerNum) {
      getShowroomOptions();
    }
  }, [orderData?.customerNum]);
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setOrderExpanded(newExpanded ? panel : false);
  };
  const handleAccordionChangeCommercial = (panel) => (event, newExpanded) => {
    setCommercialExpanded(newExpanded ? panel : false);
  };

  const handleAdditionalRevision = (e, index) => {
    const revisions = [...additionalRevision];
    revisions[index] = true;
    setAdditionalRevision(revisions);
  };

  const handleStatusChange = (data) => {
    if (
      data.value !== editOrderData?.orderStatus &&
      data.value === "ACK_FRM_FACTORY"
    ) {
      setFormOpen(true);
    } else if (
      data.value !== editOrderData?.orderStatus &&
      (editOrderData?.orderStatus === "ACK_FRM_FACTORY" ||
        editOrderData?.orderStatus === "ORDER_PLACED") &&
      data.value === "AB_RECEIVED"
    ) {
      setABReceivedOpen(true);
    }
    setStatus(data.value);
    setOrderData({
      ...orderData,
      orderStatus: data?.value,
      amendmentStatus:
        orderData?.orderStatus === "AB_RECEIVED" &&
        (orderData?.amendmentStatus === "AMENDMENT_REQUEST_NFZE" ||
          orderData?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY") &&
        data.value !== "AMENDMENT_NFZE" &&
        data.value !== "AMENDMENT_FACTORY"
          ? null
          : orderData?.amendmentStatus,
    });
  };

  const handleAssignChange = (data) => {
    setOrderData({ ...orderData, assignedTo: data?.value });
  };

  useEffect(() => {
    if (successMsg) {
      props?.handleSuccessMsg(successMsg);
    }
  }, [successMsg]);

  useEffect(() => {
    if (error) {
      props?.handleError(error);
    }
  }, [error]);

  useEffect(() => {
    if (props?.handleSaveDisabled) {
      props?.handleSaveDisabled(saveBtnDisable);
    }
  }, [saveBtnDisable]);

  const handleAnnotationComment = (data, index) => {
    const updated = [...amendmentFileData];

    updated[index].replyToQuestions = data;
    setAmendmentFileData(updated);
  };

  const removeDocument = () => {
    const selected = { ...attachmentSelectedRow };
    const rowData = selected?.node;
    rowData?.setDataValue("attachmentName", "");
    rowData?.setDataValue("attachmentFile", "");
    rowData?.setDataValue("uploadedBy", "");
    rowData?.setDataValue("uploadedDttm", "");
    rowData?.setDataValue("comments", "");
    setAttachmentSelectedRow(selected);
  };

  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    if (attachmentSelectedRow?.data?.type === "DRW*") {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension !== "drw" && fileExtension !== "prw") {
        toast.warning("Please upload a file with .drw or .prw extension");
        return;
      }
    }
    const selected = { ...attachmentSelectedRow };
    const rowData = selected?.node;
    rowData?.setDataValue("attachmentName", file.name);
    rowData?.setDataValue("attachmentFile", file);
    setAttachmentSelectedRow(selected);
  };

  const removeReviseFile = () => {
    setOrderData({ ...orderData, revisedDrawingFile: null });
  };

  const handleUploadRevisedFile = (e) => {
    const file = e.target.files[0];
    setOrderData({
      ...orderData,
      revisedDrawingFile: { attachmentFile: file, attachmentName: file.name },
    });
  };
  const handleUploadABFile = (e) => {
    const file = e.target.files[0];
    setABFiles({ attachmentFile: file, attachmentName: file.name });
  };

  const onItemCellValueChanged = (props) => {
    const allData = [];
    props.api.forEachNode((node) => {
      allData.push(node.data);
    });
    setItemData(allData);
  };

  const onDownloadCellValueChanged = (props) => {
    const allData = [];
    props?.api?.forEachNode((node) => {
      allData.push(node?.data);
    });
    setRowData(allData);
  };

  const onPartCellValueChanged = (props) => {
    const allData = [];
    props?.api?.forEachNode((node) => allData.push(node?.data));
    setPartData(allData);
    updatePartSubReasonColumn(props?.api);
  };
  const handleStartWorking = async () => {
    setSuccessMsg("");
    setError();
    try {
      await OAuthService.addData(
        url + `/api/changeOrderStatus?orderId=${params.id}&status=IN_PROGRESS`,
        "",
      );
      setSuccessMsg("Order in progress successfully.");
      getOrder();
      getOrderHistory();
      getAmmendment();
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const handleOrderPlacedBtn = async () => {
    setSuccessMsg("");
    setError();
    try {
      var targetUrl =
        url + `/api/changeOrderStatus?orderId=${params.id}&status=ORDER_PLACED`;
      if (partMailContent) {
        targetUrl = encodeURI(targetUrl + `&partOrderMail=${partMailContent}`);
      }
      await OAuthService.addData(targetUrl, "");
      toast.success("Order placed successfully.");
      getOrder();
      getOrderHistory();
      getAmmendment();
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  const handleSendToGermany = async (e) => {
    setSuccessMsg("");
    setError();
    try {
      var targetUrl = url + `/api/sendToGermay?orderId=${params.id}`;
      if (partMailContent) {
        let mailMessage = encodeURIComponent(partMailContent);
        targetUrl = targetUrl + `&partOrderMail=${mailMessage}`;
      }
      await OAuthService.addData(targetUrl, "");
      //setSuccessMsg("Order Mail Sent to Germany successfully.");
      toast.success("Order Mail Sent to Germany successfully.");
      getOrder();
      getOrderHistory();
      getAmmendment();
      setShowSendGermany(false);
    } catch (error) {
      //setError(error?.response?.data?.errorMessage || error.message);
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  const handleConfirmeOrder = async () => {
    setSuccessMsg("");
    try {
      await OAuthService.getList(
        url + `/api/confirmOrder?orderId=${params.id}`,
      );
      setSuccessMsg("Order Confirmed successfully.");
      getOrder();
      getOrderHistory();
      getAmmendment();
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  const handlePDFClose = () => {
    setOpenPDF(false);
  };
  const handleABNumberChange = async () => {
    handleFormClose();
  };

  const handleUniqueIdBlur = (e) => {
    const val = e.target.value.toUpperCase();
    setOrderData((prev) => ({
      ...prev,
      uniqueId: val,
    }));
  };
  const handleClientBlur = (e) => {
    const val = e.target.value.toUpperCase().trim();
    setOrderData((prev) => ({
      ...prev,
      clientName: val,
    }));
  };

  return (
    <>
      <div className={clsx(classes.root)}>
        <Box className="px-24 md:px-32 pt-12">
          <Tabs
            {...tabsProps}
            value={tabValue}
            indicatorColor="secondary"
            onChange={handleTabChange}
            textColor="inherit"
            sx={{ borderBottom: 1, borderColor: "divider", my: 1 }}
          >
            <Tab value={0} sx={tabSx} label="Information" />

            {hasPartnersRole ? (
              statusIndex > 5 &&
              shareAbFileName?.length > 0 &&
              shareAbFileName.some((value) => value !== null) ? (
                <Tab
                  value={1}
                  sx={tabSx}
                  label="Amendment Request/Confirmation"
                />
              ) : (
                <></>
              )
            ) : statusIndex > 5 ? (
              <Tab
                value={1}
                sx={tabSx}
                label="Amendment Request/Confirmation"
              />
            ) : (
              <></>
            )}

            <Tab value={2} sx={tabSx} label="Order History" />

            {lvDocumentInfoesList?.length > 0 ? (
              <Tab value={3} sx={tabSx} label="Delivery Delay" />
            ) : null}
          </Tabs>

          <div className={tabValue !== 0 ? "hidden" : ""}>
            <OrderToolbar
              title="Order & Account Information"
              subtitle={`${token?.name || ""}${
                token?.email ? ` · ${token.email}` : ""
              }`}
            >
              {(token?.scope?.includes("ROLE_MD") ||
                token?.scope?.includes("ROLE_ADMIN") ||
                token?.scope?.includes("ROLE_SOPDIR") ||
                token?.scope?.includes("ROLE_ORDERPRO")) &&
                (orderData?.orderStatus === "AB_RECEIVED" ||
                  orderData?.orderStatus === "UNDER_CONFIRMATION") && (
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => setABReceivedOpen(true)}
                  >
                    Upload Revised AB
                  </Button>
                )}

              <ToolbarField label="Status">
                {!hasPartnersRole ? (
                  <Select
                    required
                    options={orderStatusOption}
                    value={
                      orderData?.orderStatus === "AB_RECEIVED" &&
                      orderData?.amendmentStatus === "AMENDMENT_REQUEST_NFZE"
                        ? { label: "Amendment NFZE", value: "AMENDMENT_NFZE" }
                        : (orderData?.orderStatus === "AB_RECEIVED" ||
                            orderData?.orderStatus === "UNDER_CONFIRMATION") &&
                          orderData?.amendmentStatus ===
                            "AMENDMENT_REQUEST_FACTORY"
                        ? {
                            label: "Amendment Factory",
                            value: "AMENDMENT_FACTORY",
                          }
                        : orderStatusOption.find(
                            (obj) => orderData?.orderStatus === obj.value,
                          )
                    }
                    isDisabled={
                      orderStatusOption.length <= 1 ||
                      (["NEW", "HOLD", "ASSIGNED", "IN_PROGRESS"].includes(
                        orderData?.orderStatus,
                      )
                        ? !(
                            token?.scope?.includes("ROLE_SOPDIR") ||
                            token?.scope?.includes("ROLE_MD") ||
                            token?.scope?.includes("ROLE_ADMIN")
                          )
                        : [
                            "ACK_FRM_FACTORY",
                            "AB_RECEIVED",
                            "ORDER_PLACED",
                            "CONFIRMED",
                            "READY_TO_BOOK",
                            "PRODUCTION_PLANNING",
                            "UNDER_CONFIRMATION",
                            "RELEASED",
                            "LOADED",
                            "CANCELLED",
                          ].includes(orderData?.orderStatus)
                        ? !(
                            token?.scope?.includes("ROLE_SOPDIR") ||
                            token?.scope?.includes("ROLE_MD") ||
                            token?.scope?.includes("ROLE_ORDERPRO") ||
                            token?.scope?.includes("ROLE_ADMIN")
                          )
                        : true)
                    }
                    onChange={(e) => handleStatusChange(e)}
                    styles={customStyles()}
                    className="w-150 "
                  />
                ) : orderData?.orderStatus === "AB_RECEIVED" &&
                  orderData?.amendmentStatus === "AMENDMENT_REQUEST_NFZE" ? (
                  <TextField
                    value="Amendment NFZE"
                    isDisabled={true}
                    style={{ cursor: "not-allowed" }}
                    styles={customStyles()}
                    className="w-150 "
                  />
                ) : (orderData?.orderStatus === "AB_RECEIVED" ||
                    orderData?.orderStatus === "UNDER_CONFIRMATION") &&
                  orderData?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY" ? (
                  <TextField
                    value="Amendment Factory"
                    isDisabled={true}
                    style={{ cursor: "not-allowed" }}
                    styles={customStyles()}
                    className="w-150 "
                  />
                ) : (
                  <TextField
                    value={
                      orderData?.orderStatus === "AB_RECEIVED" &&
                      orderData?.abShareDate === null
                        ? initialStatusOption.find(
                            (obj) => obj.value === "ACK_FRM_FACTORY",
                          )?.label
                        : orderStatusOption.find(
                            (obj) => obj.value === orderData?.orderStatus,
                          )?.label
                    }
                    isDisabled={true}
                    style={{ cursor: "not-allowed" }}
                    styles={customStyles()}
                    className="w-150"
                  />
                )}
              </ToolbarField>

              {(token?.scope?.includes("ROLE_SOPDIR") ||
                token?.scope?.includes("ROLE_MD") ||
                token?.scope?.includes("ROLE_ADMIN") ||
                token?.email === "orders@noltefze.com") && (
                <ToolbarField label="Assign designer">
                  <Select
                    required
                    options={user}
                    styles={customStyles()}
                    value={
                      orderData?.assignedTo &&
                      user?.length > 0 &&
                      user?.filter((obj) => orderData?.assignedTo === obj.value)
                    }
                    className="w-150 "
                    isDisabled={
                      !orderData?.orderStatus
                        ? true
                        : (orderData?.orderStatus === "NEW" ||
                            orderData?.orderStatus === "HOLD" ||
                            orderData?.orderStatus === "IN_PROGRESS" ||
                            orderData?.orderStatus === "ASSIGNED") &&
                          (token?.scope?.includes("ROLE_SOPDIR") ||
                            token?.scope?.includes("ROLE_MD") ||
                            token?.scope?.includes("ROLE_ADMIN") ||
                            token?.email === "orders@noltefze.com")
                        ? false
                        : true
                    }
                    onChange={handleAssignChange}
                  />
                </ToolbarField>
              )}

              {(orderData?.orderStatus === "NEW" ||
                orderData?.orderStatus === "HOLD" ||
                orderData?.orderStatus === "ASSIGNED") &&
                (token?.scope?.includes("ROLE_DESIGNER") ||
                  token?.scope?.includes("ROLE_MD") ||
                  token?.scope?.includes("ROLE_ORDERPRO") ||
                  token?.scope?.includes("ROLE_ADMIN") ||
                  token?.scope?.includes("ROLE_SOPDIR") ||
                  token?.scope?.includes("ROLE_EXTORDPROCESS")) && (
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleStartWorking}
                  >
                    {orderData?.orderStatus === "HOLD"
                      ? "Continue Working"
                      : "Start Working"}
                  </Button>
                )}
              {editOrderData?.orderStatus === "IN_PROGRESS" &&
                (token?.scope?.includes("ROLE_MD") ||
                  token?.scope?.includes("ROLE_ORDERPRO") ||
                  token?.scope?.includes("ROLE_ADMIN") ||
                  token?.scope?.includes("ROLE_SOPDIR")) &&
                editOrderData?.documentType === "AO" &&
                showSendGermany && ( // Revised file optional for existing part order
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleSendToGermany}
                    disabled={orderData?.documentType === "AO" ? false : true}
                  >
                    Send To Germany
                  </Button>
                )}
              {
                /*editOrderData?.orderStatus === "ASSIGNED" ||*/
                editOrderData?.orderStatus === "IN_PROGRESS" &&
                  (token?.scope?.includes("ROLE_MD") ||
                    token?.scope?.includes("ROLE_ORDERPRO") ||
                    token?.scope?.includes("ROLE_ADMIN") ||
                    token?.scope?.includes("ROLE_SOPDIR")) &&
                  (editOrderData?.revisedDrawingFile ||
                    editOrderData?.documentType === "AO") && ( // Revised file optional for existing part order
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={handleOrderPlacedBtn}
                      disabled={
                        orderData?.revisedDrawingFile ||
                        orderData?.documentType === "AO"
                          ? false
                          : true
                      }
                    >
                      Place Order
                    </Button>
                  )
              }
              {!editOrderData?.revisedDrawingFile &&
                orderData?.orderStatus === "IN_PROGRESS" &&
                (token?.scope?.includes("ROLE_ORDERPRO") ||
                  token?.scope?.includes("ROLE_MD") ||
                  token?.scope?.includes("ROLE_SOPDIR") ||
                  token?.scope?.includes("ROLE_ADMIN") ||
                  token?.scope?.includes("ROLE_DESIGNER") ||
                  token?.scope?.includes("ROLE_EXTORDPROCESS")) && (
                  <>
                    <Button
                      component="label"
                      variant="contained"
                      color="secondary"
                      size="small"
                      // className="text-gray-900"
                      // sx={{ color: "#000 !important" }}
                      disabled={
                        orderData?.orderStatus === "IN_PROGRESS"
                          ? hasPartnerRole
                            ? false
                            : false
                          : true
                      }
                    >
                      Upload revised file
                      <VisuallyHiddenInput
                        disabled={
                          hasPartnerRole
                            ? orderData?.orderStatus === "NEW" ||
                              orderData?.orderStatus === "ASSIGNED" ||
                              orderData?.orderStatus === "IN_PROGRESS"
                              ? false
                              : true
                            : false
                        }
                        type="file"
                        accept={
                          orderData?.documentType == "SO" ? ".drw, .prw" : ".*"
                        }
                        onClick={(event) => {
                          event.target.value = null;
                        }}
                        onChange={handleUploadRevisedFile}
                      />
                    </Button>
                    <Box
                      ref={ref}
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: 1,
                        my: 1,
                      }}
                    >
                      {orderData?.revisedDrawingFile && (
                        <Stack>
                          <Box className="flex justify-between">
                            <Grid className="flex">
                              <div>
                                <FileCopyIcon
                                  fontSize={"large"}
                                  color="secondary"
                                />
                              </div>
                              <div>
                                <Typography
                                  fontSize={"large"}
                                  className="ml-12"
                                >
                                  {
                                    orderData?.revisedDrawingFile
                                      ?.attachmentName
                                  }
                                </Typography>
                              </div>
                            </Grid>
                            <Grid>
                              {orderData?.revisedDrawingFile
                                ?.attachmentName && (
                                <FuseSvgIcon
                                  className=" w-32 h-32 cursor-pointer"
                                  disabled={
                                    hasPartnerRole
                                      ? orderData?.orderStatus === "NEW" ||
                                        orderData?.orderStatus === "ASSIGNED" ||
                                        orderData?.orderStatus === "IN_PROGRESS"
                                        ? false
                                        : true
                                      : false
                                  }
                                  onClick={() => removeReviseFile()}
                                >
                                  heroicons-outline:x
                                </FuseSvgIcon>
                              )}
                            </Grid>
                          </Box>
                        </Stack>
                      )}
                    </Box>
                  </>
                )}
            </OrderToolbar>

            <Divider sx={{ mb: 1 }} />
            {orderData?.documentType == "AO" && !hasCustomerRole && (
              <TextField
                id="outlined-multiline-flexible"
                label="Part Order Email to Germany"
                fullWidth
                value={partMailContent}
                margin="dense"
                disabled={
                  orderData?.orderStatus === "NEW" ||
                  orderData?.orderStatus === "ASSIGNED" ||
                  orderData?.orderStatus === "HOLD" ||
                  orderData?.orderStatus === "IN_PROGRESS"
                    ? false
                    : true
                }
                hidden={hasPartnerRole}
                multiline
                onChange={(e) => {
                  setPartMailContent(e.target.value);
                }}
                maxRows={6}
              />
            )}
            <CustomAccordion
              panel="panel1"
              expanded={orderExpanded}
              onChange={handleAccordionChange}
              header="Order Comments"
            >
              <Box
                sx={{
                  maxHeight: { xs: 320, md: 480 },
                  overflowY: "auto",
                  pr: 0.5,
                }}
              >
                {orderData?.comments?.map((c) => {
                  const u = allUserList?.find((v) => v.email === c.user);
                  return (
                    <CommentItem
                      key={c.time}
                      isOwn={c.user === token?.email}
                      initial={c.user?.charAt(0)}
                      name={u ? `${u.firstName} ${u.lastName}` : c.user}
                      source={c.orderCommentSource}
                      time={c.time}
                      text={c.comment}
                    />
                  );
                })}
              </Box>

              {/* </Grid> */}

              <Typography sx={{ fontSize: 12, fontWeight: 600, mt: 3 }}>
                New Comment
              </Typography>
              <Grid container>
                <Grid item xs={12} sm={9}>
                  <TextField
                    placeholder="Write your comment here"
                    multiline
                    disabled={
                      (token?.scope?.includes("ROLE_PARTNRDESIGN") ||
                        token?.scope?.includes("ROLE_PARTNER_ADMIN") ||
                        token?.scope?.includes("ROLE_SHWRMMGR") ||
                        token?.scope?.includes("ROLE_MD") ||
                        token?.scope?.includes("ROLE_PARTNER") ||
                        token?.scope?.includes("ROLE_PARTNRORDPROCESS") ||
                        token?.scope?.includes("ROLE_SOPDIR") ||
                        token?.scope?.includes("ROLE_EXTORDPROCESS") ||
                        token?.scope?.includes("ROLE_DESIGNER") ||
                        token?.scope?.includes("ROLE_ORDERPRO")) &&
                      (orderData?.orderStatus === "NEW" ||
                        orderData?.orderStatus === "ASSIGNED" ||
                        orderData?.orderStatus === "IN_PROGRESS" ||
                        orderData?.orderStatus === "HOLD")
                        ? hasPartnersRole
                          ? orderData?.orderStatus === "HOLD"
                            ? false
                            : true
                          : false
                        : true
                    }
                    value={newOrderComment}
                    onChange={(e) => setNewOrderComment(e.target.value)}
                    fullWidth
                    rows={4}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleSubmitComments}
                    sx={{ mt: { sm: 1 } }}
                    disabled={
                      (token?.scope?.includes("ROLE_PARTNRDESIGN") ||
                        token?.scope?.includes("ROLE_PARTNER_ADMIN") ||
                        token?.scope?.includes("ROLE_SHWRMMGR") ||
                        token?.scope?.includes("ROLE_MD") ||
                        token?.scope?.includes("ROLE_PARTNER") ||
                        token?.scope?.includes("ROLE_PARTNRORDPROCESS") ||
                        token?.scope?.includes("ROLE_SOPDIR") ||
                        token?.scope?.includes("ROLE_EXTORDPROCESS") ||
                        token?.scope?.includes("ROLE_DESIGNER") ||
                        token?.scope?.includes("ROLE_ORDERPRO")) &&
                      (orderData?.orderStatus === "NEW" ||
                        orderData?.orderStatus === "ASSIGNED" ||
                        orderData?.orderStatus === "IN_PROGRESS" ||
                        orderData?.orderStatus === "HOLD")
                        ? hasPartnersRole
                          ? orderData?.orderStatus === "HOLD"
                            ? false
                            : true
                          : false
                        : true
                    }
                  >
                    <FuseSvgIcon>material-solid:send</FuseSvgIcon>
                  </Button>
                </Grid>
              </Grid>
            </CustomAccordion>
            {!hasCustomerPartnersRole && (
              <CustomAccordion
                panel="panel2"
                expanded={orderExpanded}
                onChange={handleAccordionChange}
                header="Order Details"
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={!hasPartnerRole ? 4 : 6}>
                    {/* <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 2 }}>
                    Order
                  </Typography> */}
                    <Box sx={{ mb: 3 }}>
                      <ul className="order-detail-summary">
                        <li className="odd flex">
                          <label>Order Date</label>
                          {orderData?.orderCreationDate &&
                            moment(orderData?.orderCreationDate).format(
                              "MMMM Do YYYY",
                            )}
                        </li>
                        <li className="even flex">
                          <label>Order Reference</label>
                          {orderData?.projectNum}
                        </li>
                        <li className="odd flex">
                          <label>Order Category</label>
                          {orderData?.orderCategory}
                        </li>
                        <li className="even flex">
                          {/* <label>Order Reference</label> BQ554901 */}
                          <label>AB Number</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              value={orderData?.abNumber}
                              error={Boolean(abNumberError)}
                              helperText={abNumberError}
                              disabled={hasPartnersRole ? true : false}
                              type="text"
                              inputProps={{ min: 0 }}
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "abNumber",
                                  data.target.value,
                                )
                              }
                            />
                          ) : (
                            orderData?.abNumber
                          )}
                        </li>
                        <li className="odd flex">
                          <label>Type Number</label>
                          {orderData?.projectNum.length === 10
                            ? orderData?.projectNum.slice(-3)
                            : orderData?.projectNum.slice(-2)}
                        </li>
                        <li className="even flex">
                          <label>Unique ID</label>

                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              value={orderData?.uniqueId || ""}
                              disabled={hasPartnersRole ? true : false}
                              type="text"
                              sx={{
                                "& input": {
                                  textTransform: "uppercase",
                                },
                              }}
                              onChange={(e) => {
                                setOrderData((prev) => ({
                                  ...prev,
                                  uniqueId: e.target.value,
                                }));
                              }}
                              onBlur={handleUniqueIdBlur}
                            />
                          ) : (
                            orderData?.uniqueId
                          )}
                        </li>
                        <li className="odd flex">
                          <label>Doc Num</label>
                          {orderData?.documentNum}
                        </li>
                        <li className="even flex">
                          <label>Doc Type</label>
                          {orderData?.documentType}
                        </li>
                        <li className="odd flex">
                          <label>Created At</label>
                          {orderData?.createdDate &&
                            moment(orderData?.createdDate).format(
                              "MMMM Do YYYY - HH:mm",
                            )}
                        </li>
                        <li className="even flex">
                          <label>Processed On</label>
                          {orderData?.processedOn &&
                            moment(orderData?.processedOn).format(
                              "MMMM Do YYYY - HH:mm",
                            )}
                        </li>
                        <li className="odd flex">
                          <label>Assigned On</label>
                          {orderData?.assignedDttm &&
                            moment(orderData?.assignedDttm).format(
                              "MMMM Do YYYY - HH:mm",
                            )}
                        </li>
                      </ul>
                    </Box>
                    <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 2 }}>
                      Commercial
                    </Typography>
                    <Box>
                      <ul className="order-detail-summary">
                        <li className="odd flex">
                          <label>WG1 List Price (Euros)*</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              value={orderData?.lpWg1}
                              inputProps={{ min: 0 }}
                              type="number"
                              onKeyDown={blockInvalidNumberKeys}
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "lpWg1",
                                  data.target.value,
                                )
                              }
                              disabled={hasPartnersRole ? true : false}
                            />
                          ) : (
                            orderData?.lpWg1 &&
                            orderData?.lpWg1?.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          )}
                        </li>
                        <li className="even flex">
                          <label>WG2 List Price (Euros)*</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              value={orderData?.lpWg2}
                              type="number"
                              onKeyDown={blockInvalidNumberKeys}
                              inputProps={{ min: 0 }}
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "lpWg2",
                                  data.target.value,
                                )
                              }
                              disabled={hasPartnersRole ? true : false}
                            />
                          ) : (
                            orderData?.lpWg2 &&
                            orderData?.lpWg2?.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          )}
                        </li>
                        <li className="odd flex">
                          <label>Total List Price (Euros)</label>
                          {orderData?.totalLpWg1Wg2 &&
                            orderData?.totalLpWg1Wg2?.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })}
                        </li>
                        <li className="even flex">
                          <label>Revised WG1</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              value={orderData?.revisedLpWg1}
                              type="number"
                              onKeyDown={blockInvalidNumberKeys}
                              inputProps={{ min: 0 }}
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "revisedLpWg1",
                                  data.target.value,
                                )
                              }
                              disabled={hasPartnersRole ? true : false}
                            />
                          ) : (
                            orderData?.revisedLpWg1 &&
                            orderData?.revisedLpWg1?.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          )}
                        </li>
                        <li className="odd flex">
                          <label>Revised WG2</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              value={orderData?.revisedLpWg2}
                              type="number"
                              onKeyDown={blockInvalidNumberKeys}
                              inputProps={{ min: 0 }}
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "revisedLpWg2",
                                  data.target.value,
                                )
                              }
                              disabled={hasPartnersRole ? true : false}
                            />
                          ) : (
                            orderData?.revisedLpWg2 &&
                            orderData?.revisedLpWg2?.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          )}
                        </li>
                        <li className="even flex">
                          <label>Total Revised</label>
                          {orderData?.totalRevisedLpWg1Wg2 &&
                            orderData?.totalRevisedLpWg1Wg2?.toLocaleString(
                              "en-US",
                              { minimumFractionDigits: 2 },
                            )}
                        </li>
                      </ul>
                    </Box>
                    {hasSopAdminRole && (
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={orderData?.skipPromotion || false}
                              onChange={(e) =>
                                setOrderData((prev) => ({
                                  ...prev,
                                  skipPromotion: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Skip promotion"
                          disabled={!props?.disableData}
                        />
                      </FormGroup>
                    )}
                  </Grid>

                  {!hasPartnerRole && (
                    <Grid item xs={12} md={4}>
                      {/* <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 2 }}>
                      Partner OP
                    </Typography> */}
                      <Box sx={{ mb: 3 }}>
                        <ul className="order-detail-summary">
                          <li className="odd flex">
                            <label>Customer</label>
                            {orderData?.customerName}
                          </li>
                          <li className="even flex">
                            <label>Showroom</label>
                            {props?.disableData && !hasLogisticsRole ? (
                              <Select
                                options={showroomOptions}
                                styles={customStyles()}
                                onChange={(data) =>
                                  handleOrderDetailChange("showroomName", data)
                                }
                                isDisabled={hasPartnersRole ? true : false}
                                value={
                                  orderData?.showroomName &&
                                  showroomOptions.length > 0 &&
                                  showroomOptions.filter(
                                    (data) =>
                                      data.label === orderData?.showroomName,
                                  )
                                }
                              />
                            ) : (
                              orderData?.showroomName
                            )}
                          </li>
                          <li className="odd flex">
                            <label>Region</label>
                            {orderData?.region}
                          </li>
                          <li className="even flex">
                            <label>Territory</label>
                            {props?.disableData && !hasLogisticsRole ? (
                              <Select
                                options={territoryOptions}
                                styles={customStyles()}
                                onChange={(data) =>
                                  handleOrderDetailChange("territory", data)
                                }
                                isDisabled={hasPartnersRole ? true : false}
                                value={
                                  territoryOptions.find(
                                    (data) =>
                                      data.value === orderData?.territory,
                                  ) || null
                                }
                              />
                            ) : (
                              orderData?.territory
                            )}
                          </li>
                          <li className="odd flex">
                            <label>Product</label>
                            {orderData?.vendorName}
                          </li>
                          <li className="even flex">
                            <label>Client Name</label>

                            {props?.disableData && !hasLogisticsRole ? (
                              <TextField
                                value={orderData?.clientName || ""}
                                disabled={hasPartnersRole ? true : false}
                                type="text"
                                sx={{
                                  "& input": {
                                    textTransform: "uppercase",
                                  },
                                }}
                                onChange={(e) => {
                                  setOrderData((prev) => ({
                                    ...prev,
                                    clientName: e.target.value,
                                  }));
                                }}
                                onBlur={handleClientBlur}
                              />
                            ) : (
                              orderData?.clientName
                            )}
                          </li>
                          <li className="odd flex">
                            <label>Commission Name</label>
                            <div>
                              <div>{liveCommissionName}</div>
                              {props?.disableData && !hasLogisticsRole && (
                                <Typography
                                  variant="caption"
                                  sx={{
                                    display: "block",
                                    color:
                                      commissionCharsRemaining < 0
                                        ? "error.main"
                                        : "text.secondary",
                                  }}
                                >
                                  {commissionCharsRemaining >= 0
                                    ? `${commissionCharsRemaining} characters remaining`
                                    : `${Math.abs(
                                        commissionCharsRemaining,
                                      )} characters over the limit`}
                                </Typography>
                              )}
                            </div>
                          </li>
                          {hasPORSOPADMINRole ? (
                            <li className="even flex">
                              <label>Created By</label>
                              {props?.disableData ? (
                                <Select
                                  options={filterOptions}
                                  styles={customStyles()}
                                  onChange={(data) =>
                                    handleOrderDetailChange(
                                      "createdByUser",
                                      data,
                                    )
                                  }
                                  isDisabled={hasPartnersRole ? true : false}
                                  value={
                                    filterOptions.find(
                                      (data) =>
                                        data.value === orderData?.createdByUser,
                                    ) || null
                                  }
                                />
                              ) : (
                                orderData?.createdByUser
                              )}
                            </li>
                          ) : (
                            <li className="even flex">
                              <label>Created By</label>
                              {orderData?.createdByUser &&
                                (allUserList?.filter(
                                  (value, index) =>
                                    value.email === orderData?.createdByUser,
                                ).length > 0
                                  ? `${
                                      allUserList?.filter(
                                        (value, index) =>
                                          value.email ===
                                          orderData?.createdByUser,
                                      )[0].firstName
                                    } ${
                                      allUserList?.filter(
                                        (value, index) =>
                                          value.email ===
                                          orderData?.createdByUser,
                                      )[0].lastName
                                    }`
                                  : orderData.createdByUser)}
                            </li>
                          )}
                        </ul>
                      </Box>
                    </Grid>
                  )}

                  <Grid item xs={12} md={!hasPartnerRole ? 4 : 6}>
                    {/* <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 2 }}>
                    German OP
                  </Typography> */}
                    <Box sx={{ mb: 3 }}>
                      <ul className="order-detail-summary">
                        {!hasCustomerRole && (
                          <>
                            <li className="odd flex">
                              <label>German OP Name</label>
                              {orderData?.orderConfirmedBy}
                            </li>
                            <li className="even flex">
                              <label>German OP Email</label>
                              {props?.disableData &&
                              !hasLogisticsRole &&
                              hasPORSOPADMINRole ? (
                                <TextField
                                  value={orderData?.orderConfirmedEmail}
                                  disabled={
                                    orderData?.orderStatus === "NEW" ||
                                    orderData?.orderStatus === "ASSIGNED" ||
                                    orderData?.orderStatus === "IN_PROGRESS" ||
                                    orderData?.orderStatus === "ORDER_PLACED" ||
                                    orderData?.orderStatus ===
                                      "ACK_FRM_FACTORY" ||
                                    orderData?.orderStatus === "AB_RECEIVED" ||
                                    orderData?.orderStatus ===
                                      "UNDER_CONFIRMATION"
                                      ? false
                                      : true
                                  }
                                  type="email"
                                  onChange={(data) =>
                                    handleOrderDetailChange(
                                      "orderConfirmedEmail",
                                      data.target.value,
                                    )
                                  }
                                />
                              ) : (
                                orderData?.orderConfirmedEmail
                              )}
                            </li>
                            <li className="odd flex">
                              <label>German OP PhoneNumber</label>
                              {orderData?.orderConfirmedPhone}
                            </li>
                          </>
                        )}

                        <li className="even flex">
                          <label>Volume(cbm)*</label>
                          {props?.disableData ? (
                            <TextField
                              value={orderData?.volume}
                              disabled={
                                hasPartnersRole
                                  ? orderData?.orderStatus === "NEW" ||
                                    orderData?.orderStatus === "ASSIGNED" ||
                                    orderData?.orderStatus === "HOLD"
                                    ? false
                                    : true
                                  : false
                              }
                              type="number"
                              onKeyDown={blockInvalidNumberKeys}
                              inputProps={{ min: 0 }}
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "volume",
                                  data.target.value,
                                )
                              }
                            />
                          ) : (
                            orderData?.volume &&
                            Number(orderData?.volume).toFixed(3)
                          )}
                        </li>
                        <li className="odd flex">
                          <label>Weight (kg)</label>
                          {props?.disableData ? (
                            <TextField
                              value={orderData?.weight}
                              disabled={
                                hasPartnersRole
                                  ? orderData?.orderStatus === "NEW" ||
                                    orderData?.orderStatus === "ASSIGNED" ||
                                    orderData?.orderStatus === "HOLD"
                                    ? false
                                    : true
                                  : false
                              }
                              type="number"
                              onKeyDown={blockInvalidNumberKeys}
                              inputProps={{ min: 0 }}
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "weight",
                                  data.target.value,
                                )
                              }
                            />
                          ) : (
                            orderData?.weight &&
                            Number(orderData?.weight).toFixed(3)
                          )}
                        </li>
                        <li className="even flex">
                          <label>Container No</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              value={orderData?.internalContainerNo}
                              disabled={hasPartnersRole ? true : false}
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "internalContainerNo",
                                  data.target.value,
                                )
                              }
                            />
                          ) : (
                            orderData?.internalContainerNo
                          )}
                        </li>
                        <li className="odd flex">
                          <label>Expected Container No</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "requestedContainer",
                                  data.target.value,
                                )
                              }
                              disabled={hasPartnersRole ? true : false}
                              value={orderData?.requestedContainer}
                            />
                          ) : (
                            orderData?.requestedContainer
                          )}
                        </li>
                        <li className="even flex">
                          <label>Loading Week</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "plannedLoadingWeek",
                                  data.target.value,
                                )
                              }
                              disabled={hasPartnersRole ? true : false}
                              type="number"
                              onKeyDown={blockInvalidNumberKeys}
                              inputProps={{ min: 0 }}
                              value={orderData?.plannedLoadingWeek}
                            />
                          ) : (
                            orderData?.plannedLoadingWeek
                          )}
                        </li>
                        <li className="odd flex ">
                          <label className="min-w-[120px]">Loading Date</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <Box className="w-[150px]">
                              <CustomDatePicker
                                placeholder="Loading Date"
                                className="h-[25px] w-full"
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "25px",
                                    minHeight: "25px",
                                  },
                                }}
                                format={"dd-MM-yyyy"}
                                name={"plannedLoadingDate"}
                                value={orderData?.plannedLoadingDate || null}
                                handleChange={(date) =>
                                  handleOrderDetailChange(
                                    "plannedLoadingDate",
                                    date
                                      ? moment(date).format("YYYY-MM-DD")
                                      : null,
                                  )
                                }
                                componentsProps={{
                                  actionBar: { actions: ["clear"] },
                                }}
                                disabled={hasPartnersRole ? true : false}
                              />
                            </Box>
                          ) : moment(
                              orderData?.plannedLoadingDate,
                            ).isValid() ? (
                            moment(orderData?.plannedLoadingDate).format(
                              "DD-MM-YYYY",
                            )
                          ) : (
                            ""
                          )}
                        </li>
                        <li className="even flex">
                          <label>Expected Loading Week*</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <Select
                              options={loadingWeekOptions}
                              styles={customStyles()}
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "loadingWeek",
                                  data.value,
                                )
                              }
                              isDisabled={
                                hasPartnersRole
                                  ? orderData?.orderStatus === "NEW" ||
                                    orderData?.orderStatus === "ASSIGNED" ||
                                    orderData?.orderStatus === "HOLD"
                                    ? false
                                    : true
                                  : false
                              }
                              value={
                                orderData?.loadingWeek &&
                                loadingWeekOptions.length > 0 &&
                                loadingWeekOptions.filter(
                                  (data) =>
                                    data.value === orderData?.loadingWeek,
                                )
                              }
                            />
                          ) : (
                            orderData?.loadingWeek
                          )}
                        </li>
                        <li className="odd flex">
                          <label>Actual Container No</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "actualContainerNo",
                                  data.target.value,
                                )
                              }
                              disabled={hasPartnersRole ? true : false}
                              value={orderData?.actualContainerNo}
                            />
                          ) : (
                            orderData?.actualContainerNo
                          )}
                        </li>
                        <li className="even flex">
                          <label>Actual Loading Week</label>
                          {props?.disableData ? (
                            <TextField
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "actualLoadingWeek",
                                  data.target.value,
                                )
                              }
                              type="number"
                              onKeyDown={blockInvalidNumberKeys}
                              inputProps={{ min: 0 }}
                              disabled={hasPartnersRole ? true : false}
                              value={orderData?.actualLoadingWeek}
                            />
                          ) : (
                            orderData?.actualLoadingWeek
                          )}
                        </li>
                        <li className="odd flex">
                          <label>Actual Loading Date</label>
                          {props?.disableData ? (
                            <Box className="w-[150px]">
                              <CustomDatePicker
                                placeholder="Loading Date"
                                className="h-[25px] w-full"
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "25px",
                                    minHeight: "25px",
                                  },
                                }}
                                format={"dd-MM-yyyy"}
                                name={"actualLoadingDate"}
                                value={orderData?.actualLoadingDate || null}
                                handleChange={(date) =>
                                  handleOrderDetailChange(
                                    "actualLoadingDate",
                                    date
                                      ? moment(date).format("YYYY-MM-DD")
                                      : null,
                                  )
                                }
                                componentsProps={{
                                  actionBar: { actions: ["clear"] },
                                }}
                                disabled={hasPartnersRole ? true : false}
                              />
                            </Box>
                          ) : moment(orderData?.actualLoadingDate).isValid() ? (
                            moment(orderData?.actualLoadingDate).format(
                              "DD-MM-YYYY",
                            )
                          ) : (
                            ""
                          )}
                        </li>
                        <li className="even flex">
                          <label>Freight*</label>
                          {props?.disableData ? (
                            <Select
                              options={freightOptions}
                              styles={customStyles()}
                              value={
                                orderData?.freight &&
                                freightOptions.length > 0 &&
                                freightOptions.filter(
                                  (data) => data.value === orderData?.freight,
                                )
                              }
                              isDisabled={
                                hasPartnersRole
                                  ? orderData?.orderStatus === "NEW" ||
                                    orderData?.orderStatus === "ASSIGNED" ||
                                    orderData?.orderStatus === "HOLD"
                                    ? false
                                    : true
                                  : false
                              }
                              onChange={(data) => {
                                handleOrderDetailChange("freight", data);
                              }}
                            />
                          ) : (
                            orderData?.freight
                          )}
                        </li>
                        <li className="odd flex">
                          <label>Special Comments</label>
                          {props?.disableData && !hasLogisticsRole ? (
                            <TextField
                              value={orderData?.specialRemark1}
                              multiline
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "specialRemark1",
                                  data.target.value,
                                )
                              }
                              disabled={
                                hasPartnersRole
                                  ? orderData?.orderStatus === "NEW" ||
                                    orderData?.orderStatus === "ASSIGNED" ||
                                    orderData?.orderStatus === "HOLD"
                                    ? false
                                    : true
                                  : false
                              }
                              rows={2}
                            />
                          ) : (
                            orderData?.specialRemark1
                          )}
                        </li>
                        {!hasCustomerRole && (
                          <>
                            <li className="even flex">
                              <label>Hubspot Reference</label>
                              {orderData?.hubspotReference}
                            </li>
                            <li className="odd  flex">
                              <label>Hubspot RCBL</label>
                              {orderData?.hubspotRcb1}
                            </li>
                          </>
                        )}
                      </ul>
                    </Box>
                  </Grid>
                </Grid>
              </CustomAccordion>
            )}
            {canViewCommercial() && (
              <CustomAccordion
                panel="panel3"
                expanded={commercialExpanded}
                onChange={handleAccordionChangeCommercial}
                header="Commercial"
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={!hasPartnerRole ? 4 : 6}>
                    <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 2 }}>
                      Receivable
                    </Typography>
                    <Box>
                      <ul className="order-detail-summary">
                        <li className="odd flex">
                          <label>Receivable</label>
                          {orderData?.grandTotal &&
                            Number(orderData.grandTotal).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                        </li>
                        <li className="even flex">
                          <label>Std Disc/ WG1</label>
                          {orderData?.stdDiscWg1 &&
                            `${Number(orderData.stdDiscWg1).toFixed(3)}%`}
                        </li>
                        <li className="odd flex">
                          <label>Spl Disc/ WG1</label>
                          {props?.disableData ? (
                            <TextField
                              value={orderData?.splDiscWg1}
                              type="number"
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "splDiscWg1",
                                  data.target.value,
                                )
                              }
                              // disabled={orderData?.proformaStatus === "READY_TO_PI" ||orderData?.proformaStatus === "PI_ISSUED"?true:false   }
                            />
                          ) : (
                            orderData?.splDiscWg1 &&
                            `${Number(orderData.splDiscWg1).toFixed(3)}%`
                          )}
                        </li>
                        <li className="even flex">
                          <label>SDR WG1</label>
                          {orderData?.sdrWg1 &&
                            `${Number(orderData.sdrWg1).toFixed(3)}%`}
                        </li>
                        <li className="odd flex">
                          <label>PDR WG1</label>
                          {orderData?.promoDiscWg1 &&
                            `${Number(orderData.promoDiscWg1).toFixed(3)}%`}
                        </li>
                        <li className="even flex">
                          <label>Cum Disc/ WG1</label>
                          {orderData?.totalDiscWg1 &&
                            `${Number(orderData.totalDiscWg1).toFixed(3)}%`}
                        </li>
                        <li className="odd flex">
                          <label>Std Disc/ WG2</label>
                          {orderData?.stdDiscWg2 &&
                            `${Number(orderData.stdDiscWg2).toFixed(3)}%`}
                        </li>
                        <li className="even flex">
                          <label>Spl Disc/ WG2</label>
                          {props?.disableData ? (
                            <TextField
                              value={orderData?.splDiscWg2}
                              type="number"
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "splDiscWg2",
                                  data.target.value,
                                )
                              }
                              //  disabled={orderData?.proformaStatus === "READY_TO_PI" ||orderData?.proformaStatus === "PI_ISSUED"?true:false   }
                            />
                          ) : (
                            orderData?.splDiscWg2 &&
                            `${Number(orderData.splDiscWg2).toFixed(3)}%`
                          )}
                        </li>
                        <li className="odd flex">
                          <label>SDR WG2</label>
                          {orderData?.sdrWg2 &&
                            `${Number(orderData.sdrWg2).toFixed(3)}%`}
                        </li>
                        <li className="even flex">
                          <label>PDR WG2</label>
                          {orderData?.promoDiscWg2 &&
                            `${Number(orderData.promoDiscWg2).toFixed(3)}%`}
                        </li>
                        <li className="odd flex">
                          <label>Cum Disc/ WG2</label>
                          {orderData?.totalDiscWg2 &&
                            `${Number(orderData.totalDiscWg2).toFixed(3)}%`}
                        </li>
                        <li className="even flex">
                          <label>Margin</label>
                          {(() => {
                            const grandTotal =
                              Number(orderData?.grandTotal) || 0;
                            const netPayable =
                              Number(orderData?.netPayable) || 0;
                            const margin = grandTotal - netPayable;

                            return margin.toLocaleString("en-US", {
                              minimumFractionDigits: 3,
                              maximumFractionDigits: 3,
                            });
                          })()}
                        </li>
                        <li className="odd flex">
                          <label>Gesture to Customer</label>
                          {orderData?.totalDiscWg1Wg2 &&
                            Number(orderData.totalDiscWg1Wg2).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                        </li>
                        <li className="even flex">
                          <label>WG1 Price Increase</label>
                          {orderData?.wg1PriceIncrease &&
                            `${Number(orderData.wg1PriceIncrease).toFixed(3)}%`}
                        </li>
                        <li className="odd flex">
                          <label>WG2 Price Increase</label>
                          {orderData?.wg2PriceIncrease &&
                            `${Number(orderData.wg2PriceIncrease).toFixed(3)}%`}
                        </li>
                        <li className="even flex">
                          <label>After WG1 Price Increase</label>
                          {orderData?.afterPriceIncreaseWg1 &&
                            Number(
                              orderData.afterPriceIncreaseWg1,
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </li>
                        <li className="odd flex">
                          <label>After WG2 Price Increase</label>
                          {orderData?.afterPriceIncreaseWg2 &&
                            Number(
                              orderData.afterPriceIncreaseWg2,
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </li>
                      </ul>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={!hasPartnerRole ? 4 : 6}>
                    <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 2 }}>
                      Payable
                    </Typography>
                    <Box>
                      <ul className="order-detail-summary">
                        <li className="odd flex">
                          <label>Payable</label>
                          {orderData?.netPayable &&
                            Number(orderData.netPayable).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                        </li>
                        <li className="even flex">
                          <label>Std Disc/ WG1</label>
                          {orderData?.stdDiscWG1Payable &&
                            `${Number(orderData.stdDiscWG1Payable).toFixed(
                              3,
                            )}%`}
                        </li>
                        <li className="odd flex">
                          <label>Spl Disc/ WG1</label>
                          {props?.disableData ? (
                            <TextField
                              value={orderData?.splDiscWG1Payable}
                              type="number"
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "splDiscWG1Payable",
                                  data.target.value,
                                )
                              }
                              //  disabled={orderData?.proformaStatus === "READY_TO_PI" ||orderData?.proformaStatus === "PI_ISSUED"?true:false   }
                            />
                          ) : (
                            orderData?.splDiscWG1Payable &&
                            `${Number(orderData.splDiscWG1Payable).toFixed(3)}%`
                          )}
                        </li>
                        <li className="even flex">
                          <label>SDP WG1</label>
                          {orderData?.sdpWg1 &&
                            `${Number(orderData.sdpWg1).toFixed(3)}%`}
                        </li>
                        <li className="odd flex">
                          <label>PDP WG1</label>
                          {orderData?.promoDiscWg1Payable &&
                            `${Number(orderData.promoDiscWg1Payable).toFixed(
                              3,
                            )}%`}
                        </li>
                        <li className="even flex">
                          <label>Cum Disc/ WG1</label>
                          {orderData?.totalDiscWG1Payable &&
                            `${Number(orderData.totalDiscWG1Payable).toFixed(
                              3,
                            )}%`}
                        </li>
                        <li className="odd flex">
                          <label>Std Disc/ WG2</label>
                          {orderData?.stdDiscWG2Payable &&
                            `${Number(orderData.stdDiscWG2Payable).toFixed(
                              3,
                            )}%`}
                        </li>
                        <li className="even flex">
                          <label>Spl Disc/ WG2</label>
                          {props?.disableData ? (
                            <TextField
                              value={orderData?.splDiscWG2Payable}
                              type="number"
                              onChange={(data) =>
                                handleOrderDetailChange(
                                  "splDiscWG2Payable",
                                  data.target.value,
                                )
                              }
                              // disabled={orderData?.proformaStatus === "READY_TO_PI" ||orderData?.proformaStatus === "PI_ISSUED"?true:false   }
                            />
                          ) : (
                            orderData?.splDiscWG2Payable &&
                            `${Number(orderData.splDiscWG2Payable).toFixed(3)}%`
                          )}
                        </li>
                        <li className="odd flex">
                          <label>SDP WG2</label>
                          {orderData?.sdpWg2 &&
                            `${Number(orderData.sdpWg2).toFixed(3)}%`}
                        </li>
                        <li className="even flex">
                          <label>PDP WG2</label>
                          {orderData?.promoDiscWg2Payable &&
                            `${Number(orderData.promoDiscWg2Payable).toFixed(
                              3,
                            )}%`}
                        </li>
                        <li className="odd flex">
                          <label>Cum Disc/ WG2</label>
                          {orderData?.totalDiscWG2Payable &&
                            `${Number(orderData.totalDiscWG2Payable).toFixed(
                              3,
                            )}%`}
                        </li>

                        <li className="even flex">
                          <label>Gesture from Vendor</label>
                          {orderData?.totalDiscWg1Wg2Payable &&
                            Number(
                              orderData.totalDiscWg1Wg2Payable,
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </li>
                        <li className="odd flex">
                          <label>Transfer Disc/WG1</label>
                          {orderData?.transferDiscountWg1 &&
                            `${Number(orderData.transferDiscountWg1).toFixed(
                              3,
                            )}%`}
                        </li>
                        <li className="even flex">
                          <label>Transfer Disc/WG2</label>
                          {orderData?.transferDiscountWg2 &&
                            `${Number(orderData.transferDiscountWg2).toFixed(
                              3,
                            )}%`}
                        </li>
                        <li className="odd flex">
                          <label>PBL after Transfer DISC</label>
                          {orderData?.payableAfterTransferDiscountWg1Wg2 &&
                            Number(
                              orderData.payableAfterTransferDiscountWg1Wg2,
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </li>
                        <li className="even flex">
                          <label>German VAT %</label>
                          {orderData?.germanVatPercent &&
                            `${Number(orderData.germanVatPercent).toFixed(3)}%`}
                        </li>
                        <li className="odd flex">
                          <label>German VAT</label>
                          {orderData?.germanVatAmt &&
                            Number(orderData.germanVatAmt).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                        </li>
                        <li className="even flex">
                          <label>PBL after VAT</label>
                          {orderData?.payableAfterGermanVat &&
                            Number(
                              orderData.payableAfterGermanVat,
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </li>
                        <li className="odd flex">
                          <label>WG1 Price Increase</label>
                          {orderData?.wg1PriceIncreasePayable &&
                            `${Number(
                              orderData.wg1PriceIncreasePayable,
                            ).toFixed(3)}%`}
                        </li>
                        <li className="even flex">
                          <label>WG2 Price Increase</label>
                          {orderData?.wg2PriceIncreasePayable &&
                            `${Number(
                              orderData.wg2PriceIncreasePayable,
                            ).toFixed(3)}%`}
                        </li>
                        <li className="odd flex">
                          <label>After WG1 Price Increase</label>
                          {orderData?.payableAfterWg1PriceIncrease &&
                            Number(
                              orderData.payableAfterWg1PriceIncrease,
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </li>
                        <li className="even flex">
                          <label>After WG2 Price Increase</label>
                          {orderData?.payableAfterWg2PriceIncrease &&
                            Number(
                              orderData.payableAfterWg2PriceIncrease,
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </li>
                      </ul>
                    </Box>
                  </Grid>
                </Grid>
              </CustomAccordion>
            )}

            {isOpen && (
              <Modal
                src={pictureSrc}
                type={pictureType}
                alt="snow"
                onClose={() => setIsOpen(false)}
              />
            )}
            <SectionHeader title="Materials">
              {!hasLogisticsRole && (
                <span className="flex w-full items-center justify-end">
                  {itemData && itemData.length < 3 && (
                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{ minWidth: "auto" }}
                      size="small"
                      onClick={addItemRow}
                      disabled={
                        props?.disableData
                          ? hasPartnerRole
                            ? orderData?.orderStatus === "NEW" ||
                              orderData?.orderStatus === "ASSIGNED" ||
                              orderData?.orderStatus === "HOLD"
                              ? false
                              : true
                            : false
                          : true
                      }
                    >
                      <FuseSvgIcon size={18}>material-solid:add</FuseSvgIcon>
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    sx={{ minWidth: "auto" }}
                    disabled={
                      props?.disableData && itemSelectedRow.length > 0
                        ? hasPartnerRole
                          ? orderData?.orderStatus === "NEW" ||
                            orderData?.orderStatus === "ASSIGNED" ||
                            orderData?.orderStatus === "HOLD"
                            ? false
                            : true
                          : false
                        : true
                    }
                    onClick={editItemRow}
                  >
                    <FuseSvgIcon size={18}>material-solid:edit</FuseSvgIcon>
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    sx={{ minWidth: "auto" }}
                    disabled={
                      props?.disableData &&
                      itemSelectedRow.length > 0 &&
                      itemData.length > 1
                        ? hasPartnerRole
                          ? orderData?.orderStatus === "NEW" ||
                            orderData?.orderStatus === "ASSIGNED" ||
                            orderData?.orderStatus === "HOLD"
                            ? false
                            : true
                          : false
                        : true
                    }
                    onClick={deleteItemRow}
                  >
                    <FuseSvgIcon size={18}>material-solid:delete</FuseSvgIcon>
                  </Button>
                </span>
              )}
            </SectionHeader>
            <div className="order-grid grid-left" style={{ height: "130px" }}>
              {orderData && (
                <AgGridTable
                  columnDefs={columnItemDefs}
                  onGridReady={onGridReady}
                  gridRef={gridRefItems}
                  rowData={itemData}
                  onCellValueChanged={onItemCellValueChanged}
                  rowGroupPanelShow={"never"}
                  rowHeight={22}
                  headerHeight={30}
                  pagination={false}
                  onSelectionChanged={onSelectionItemChanged}
                  hideCheckbox={true}
                  columnTypes={columnTypes}
                  editable={
                    hasPartnerRole
                      ? orderData?.orderStatus === "NEW" ||
                        orderData?.orderStatus === "ASSIGNED" ||
                        orderData?.orderStatus === "HOLD"
                        ? true
                        : false
                      : true
                  }
                />
              )}
            </div>

            <SectionHeader title=" Order Attachments">
              {!hasLogisticsRole && (
                <span className="flex w-full items-center justify-end">
                  <Button
                    variant="contained"
                    color="secondary"
                    sx={{ minWidth: "auto" }}
                    size="small"
                    disabled={
                      props?.disableData
                        ? hasPartnerRole
                          ? orderData?.orderStatus === "NEW" ||
                            orderData?.orderStatus === "ASSIGNED" ||
                            orderData?.orderStatus === "HOLD"
                            ? false
                            : true
                          : false
                        : true
                    }
                    onClick={addDownloadRow}
                  >
                    <FuseSvgIcon size={18}>material-solid:add</FuseSvgIcon>
                  </Button>
                </span>
              )}
            </SectionHeader>
            <div className="order-grid grid-left" style={{ height: "250px" }}>
              <AgGridTable
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                gridRef={gridRefDownload}
                rowData={rowData}
                rowGroupPanelShow={"never"}
                rowHeight={22}
                headerHeight={30}
                pagination={false}
                editable={false}
                onCellValueChanged={onDownloadCellValueChanged}
                onSelectionChanged={onSelectionDownloadChanged}
                hideCheckbox={true}
                columnTypes={columnTypes}
              />
            </div>

            {orderData?.documentType === "AO" && (
              <>
                <SectionHeader title="Part Order Details">
                  {!hasLogisticsRole && (
                    <span className="flex w-full items-center justify-end">
                      <Button
                        variant="contained"
                        color="secondary"
                        sx={{ minWidth: "auto" }}
                        disabled={
                          props?.disableData
                            ? hasPartnerRole
                              ? orderData?.orderStatus === "NEW" ||
                                orderData?.orderStatus === "ASSIGNED" ||
                                orderData?.orderStatus === "IN_PROGRESS"
                                ? false
                                : true
                              : false
                            : true
                        }
                        size="small"
                        onClick={addPartRow}
                      >
                        <FuseSvgIcon size={18}>material-solid:add</FuseSvgIcon>
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        sx={{ minWidth: "auto" }}
                        disabled={
                          props?.disableData && partSelectedRow.length > 0
                            ? hasPartnerRole
                              ? orderData?.orderStatus === "NEW" ||
                                orderData?.orderStatus === "ASSIGNED" ||
                                orderData?.orderStatus === "IN_PROGRESS"
                                ? false
                                : true
                              : false
                            : true
                        }
                        onClick={editPartRow}
                      >
                        <FuseSvgIcon size={18}>material-solid:edit</FuseSvgIcon>
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        sx={{ minWidth: "auto" }}
                        disabled={
                          props?.disableData && partSelectedRow.length > 0
                            ? hasPartnerRole
                              ? orderData?.orderStatus === "NEW" ||
                                orderData?.orderStatus === "ASSIGNED" ||
                                orderData?.orderStatus === "IN_PROGRESS"
                                ? false
                                : true
                              : false
                            : true
                        }
                        onClick={deletePartRow}
                      >
                        <FuseSvgIcon size={18}>
                          material-solid:delete
                        </FuseSvgIcon>
                      </Button>
                    </span>
                  )}
                </SectionHeader>
                <div
                  className="order-grid grid-left"
                  style={{ height: "250px" }}
                >
                  <AgGridTable
                    columnDefs={partColumnDefs}
                    onGridReady={onGridReady}
                    gridRef={gridRefPartOrder}
                    rowData={partData}
                    rowGroupPanelShow={"never"}
                    rowHeight={22}
                    headerHeight={30}
                    pagination={false}
                    onCellValueChanged={onPartCellValueChanged}
                    onCellEditingStopped={onPartCellValueChanged}
                    editable={
                      hasPartnerRole
                        ? orderData?.orderStatus === "NEW" ||
                          orderData?.orderStatus === "ASSIGNED" ||
                          orderData?.orderStatus === "IN_PROGRESS"
                          ? true
                          : false
                        : true
                    }
                    hideCheckbox={true}
                    onSelectionChanged={onSelectionPartChanged}
                    columnTypes={columnTypes}
                  />
                </div>
              </>
            )}
          </div>
          {/* <div className={tabValue !== 1 ? "hidden" : ""}>Item Two</div> */}
          <div className={tabValue !== 1 ? "hidden" : ""}>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row flex-1 items-center justify-end mb-10">
              <span className="mr-10">
                Loading Week :{" "}
                {orderData?.plannedLoadingWeek
                  ? orderData?.plannedLoadingWeek
                  : "On Hold"}
              </span>
              {orderData?.cutoffDate && (
                <span>
                  Last Alteration Date :{" "}
                  {orderData?.cutoffDate &&
                    moment(orderData?.cutoffDate).format("DD-MM-YYYY")}
                </span>
              )}
            </div>
            {amendmentFileData.length > 0 &&
              amendmentFileData.map((files, index) => {
                return (
                  <AmendmentDetails
                    amendmentFileData={amendmentFileData}
                    files={files}
                    index={index}
                    amendmentIndex={index}
                    editAmendmentFileData={editAmendmentFileData}
                    hasPartnersRole={hasPartnersRole}
                    orderData={orderData}
                    additionalRevision={additionalRevision}
                    listOfRevisions={listOfRevisions}
                    hasPORSOPRole={hasPORSOPRole}
                    token={token}
                    hasPartnerRole={hasPartnerRole}
                    hasCustomerRole={hasCustomerRole}
                    columnTypes={columnTypes}
                    ColorButton={ColorButton}
                    setAmendmentUpdateStatus={setAmendmentUpdateStatus}
                    getAmmendment={getAmmendment}
                    allUserList={allUserList}
                  />
                );
              })}
          </div>
          <div className={tabValue !== 2 ? "hidden" : ""}>
            <List>
              {orderHistory.map((h) => {
                const u = allUserList?.find((v) => v.email === h?.user);
                return (
                  <CommentItem
                    key={`history_${h?.id}`}
                    initial={h?.user?.charAt(0)}
                    name={u ? `${u.firstName} ${u.lastName}` : h?.user}
                    time={h?.time}
                    text={h?.change}
                  />
                );
              })}
            </List>
          </div>
          <div className={tabValue !== 3 ? "hidden" : ""}>
            <DeliveryDelay lvDocumentInfoesList={lvDocumentInfoesList} />
          </div>
        </Box>
      </div>

      <OrderDetailDialogs
        openAttachment={openAttachment}
        onCloseAttachment={handleAttachmentClose}
        attachmentSelectedRow={attachmentSelectedRow}
        onDocumentChange={handleDocumentChange}
        onRemoveDocument={removeDocument}
        openDelete={openDelete}
        onCloseDelete={handleDeleteClose}
        onConfirmDelete={handleDeleteConfirm}
        formOpen={formOpen}
        onCloseForm={handleFormClose}
        ABNo={ABNo}
        setABNo={setABNo}
        onSaveABNo={handleABNumberChange}
        ABSendOpen={ABSendOpen}
        onCloseABSend={handleABUploadClose}
        sendCustomerABFile={sendCustomerABFile}
        onUploadCustomerABFile={handleUploadCustomerABFile}
        onClearCustomerABFile={() => setSendCustomerABFile("")}
        onSendCustomerAB={handleABFileCustomer}
        ABReceivedOpen={ABReceivedOpen}
        onCloseABReceived={handleABReceviedClose}
        ABFiles={ABFiles}
        onUploadABFile={handleUploadABFile}
        onClearABFile={() => setABFiles("")}
        onUploadAB={handleABRecevied}
      />
      <div ref={viewerPDF}></div>
    </>
  );
});

export default OrderDetail;
